var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _rect, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporateQr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2624_43446)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2624_43446",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2998 0H0.299805V40H40.2998V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2624_43446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2998 0H0.299805V40H40.2998V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2624_43446",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 6,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2998 4V5.6C2.2998 6.13043 2.51052 6.63914 2.88559 7.01421C3.26066 7.38929 3.76937 7.6 4.2998 7.6H5.8998C6.43024 7.6 6.93895 7.38929 7.31402 7.01421C7.68909 6.63914 7.8998 6.13043 7.8998 5.6V4C7.8998 3.46957 7.68909 2.96086 7.31402 2.58579C6.93895 2.21071 6.43024 2 5.8998 2H4.2998C3.76937 2 3.26066 2.21071 2.88559 2.58579C2.51052 2.96086 2.2998 3.46957 2.2998 4ZM4.2998 2.8H5.8998C6.21806 2.8 6.52329 2.92643 6.74833 3.15147C6.97338 3.37652 7.0998 3.68174 7.0998 4V5.6C7.0998 5.91826 6.97338 6.22348 6.74833 6.44853C6.52329 6.67357 6.21806 6.8 5.8998 6.8H4.2998C3.98154 6.8 3.67632 6.67357 3.45128 6.44853C3.22623 6.22348 3.0998 5.91826 3.0998 5.6V4C3.0998 3.68174 3.22623 3.37652 3.45128 3.15147C3.67632 2.92643 3.98154 2.8 4.2998 2.8Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2624_43446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8998 2H2.2998V7.6H7.8998V2Z",
    fill: "#191986"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2624_43446",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 4,
    height: 3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0999 6.0001C5.76264 6.0001 6.2999 5.46284 6.2999 4.8001C6.2999 4.13736 5.76264 3.6001 5.0999 3.6001C4.43716 3.6001 3.8999 4.13736 3.8999 4.8001C3.8999 5.46284 4.43716 6.0001 5.0999 6.0001Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2624_43446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2999 3.6001H3.8999V6.0001H6.2999V3.6001Z",
    fill: "#191986"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2624_43446",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 2,
    width: 7,
    height: 6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2998 2L34.6998 2C34.1694 2 33.6607 2.21071 33.2856 2.58579C32.9105 2.96086 32.6998 3.46957 32.6998 4V5.6C32.6998 6.13043 32.9105 6.63914 33.2856 7.01421C33.6607 7.38929 34.1694 7.6 34.6998 7.6H36.2998C36.8302 7.6 37.3389 7.38929 37.714 7.01421C38.0891 6.63914 38.2998 6.13043 38.2998 5.6V4C38.2998 3.46957 38.0891 2.96086 37.714 2.58579C37.3389 2.21071 36.8302 2 36.2998 2ZM37.4998 4V5.6C37.4998 5.91826 37.3734 6.22348 37.1483 6.44853C36.9233 6.67357 36.6181 6.8 36.2998 6.8H34.6998C34.3815 6.8 34.0763 6.67357 33.8513 6.44853C33.6262 6.22348 33.4998 5.91826 33.4998 5.6V4C33.4998 3.68174 33.6262 3.37651 33.8513 3.15147C34.0763 2.92643 34.3815 2.8 34.6998 2.8H36.2998C36.6181 2.8 36.9233 2.92643 37.1483 3.15147C37.3734 3.37651 37.4998 3.68174 37.4998 4Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2624_43446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2997 2H32.6997V7.6H38.2997V2Z",
    fill: "#191986"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2624_43446",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 3,
    width: 3,
    height: 3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2997 4.8001C34.2997 5.46284 34.837 6.0001 35.4997 6.0001C36.1624 6.0001 36.6997 5.46284 36.6997 4.8001C36.6997 4.13736 36.1624 3.6001 35.4997 3.6001C34.837 3.6001 34.2997 4.13736 34.2997 4.8001Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2624_43446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6998 3.6001H34.2998V6.0001H36.6998V3.6001Z",
    fill: "#191986"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2624_43446",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 32,
    width: 6,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2998 38H5.8998C6.43024 38 6.93894 37.7893 7.31402 37.4142C7.68909 37.0391 7.8998 36.5304 7.8998 36V34.4C7.8998 33.8696 7.68909 33.3609 7.31402 32.9858C6.93894 32.6107 6.43024 32.4 5.8998 32.4H4.2998C3.76937 32.4 3.26066 32.6107 2.88559 32.9858C2.51052 33.3609 2.2998 33.8696 2.2998 34.4L2.2998 36C2.2998 36.5304 2.51052 37.0391 2.88559 37.4142C3.26066 37.7893 3.76937 38 4.2998 38ZM3.0998 36V34.4C3.0998 34.0817 3.22623 33.7765 3.45128 33.5515C3.67632 33.3264 3.98154 33.2 4.2998 33.2H5.8998C6.21806 33.2 6.52329 33.3264 6.74833 33.5515C6.97337 33.7765 7.0998 34.0817 7.0998 34.4V36C7.0998 36.3183 6.97337 36.6235 6.74833 36.8485C6.52329 37.0736 6.21806 37.2 5.8998 37.2H4.2998C3.98154 37.2 3.67632 37.0736 3.45128 36.8485C3.22623 36.6235 3.0998 36.3183 3.0998 36Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2624_43446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8998 32.3999H2.2998V37.9999H7.8998V32.3999Z",
    fill: "#191986"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2624_43446",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 34,
    width: 4,
    height: 3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2999 35.1999C6.2999 34.5372 5.76264 33.9999 5.0999 33.9999C4.43716 33.9999 3.8999 34.5372 3.8999 35.1999C3.8999 35.8626 4.43716 36.3999 5.0999 36.3999C5.76264 36.3999 6.2999 35.8626 6.2999 35.1999Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2624_43446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2999 34H3.8999V36.4H6.2999V34Z",
    fill: "#191986"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.0332,
    y: 17.7334,
    width: 4.53333,
    height: 4.53333,
    fill: "url(#pattern0_2624_43446)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2624_43446",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 37,
    height: 36
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 2.7998V1.9998H10.6996C10.5935 1.9998 10.4918 2.04195 10.4168 2.11696C10.3418 2.19198 10.2996 2.29372 10.2996 2.3998C10.2996 2.50589 10.3418 2.60763 10.4168 2.68265C10.4918 2.75766 10.5935 2.7998 10.6996 2.7998",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 2V2.8H11.8996V2.4C11.8996 2.29391 11.8575 2.19217 11.7825 2.11716C11.7074 2.04214 11.6057 2 11.4996 2",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 2.7998H14.2995V1.9998H13.8995C13.7934 1.9998 13.6917 2.04195 13.6167 2.11696C13.5417 2.19198 13.4995 2.29372 13.4995 2.3998",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 2V2.8H14.6998C14.8059 2.8 14.9076 2.75786 14.9826 2.68284C15.0577 2.60783 15.0998 2.50609 15.0998 2.4C15.0998 2.29391 15.0577 2.19217 14.9826 2.11716C14.9076 2.04214 14.8059 2 14.6998 2",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8995 2.8C18.1204 2.8 18.2995 2.62091 18.2995 2.4C18.2995 2.17909 18.1204 2 17.8995 2C17.6786 2 17.4995 2.17909 17.4995 2.4C17.4995 2.62091 17.6786 2.8 17.8995 2.8Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8999 2.7998H20.6999V1.9998H20.2999C20.1938 1.9998 20.0921 2.04195 20.0171 2.11696C19.942 2.19198 19.8999 2.29372 19.8999 2.3998",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6997 2V2.8H21.4997V2.4C21.4997 2.29391 21.4576 2.19217 21.3826 2.11716C21.3075 2.04214 21.2058 2 21.0997 2",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 2.7998V1.9998H22.6996C22.5935 1.9998 22.4918 2.04195 22.4168 2.11696C22.3418 2.19198 22.2996 2.29372 22.2996 2.3998C22.2996 2.50589 22.3418 2.60763 22.4168 2.68265C22.4918 2.75766 22.5935 2.7998 22.6996 2.7998",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 2V2.8H23.4996C23.6057 2.8 23.7074 2.75786 23.7825 2.68284C23.8575 2.60783 23.8996 2.50609 23.8996 2.4C23.8996 2.29391 23.8575 2.19217 23.7825 2.11716C23.7074 2.04214 23.6057 2 23.4996 2",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 2.7998H26.2995V1.9998H25.8995C25.7934 1.9998 25.6917 2.04195 25.6167 2.11696C25.5417 2.19198 25.4995 2.29372 25.4995 2.3998",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2998 2V2.8H26.6998C26.8059 2.8 26.9076 2.75786 26.9826 2.68284C27.0577 2.60783 27.0998 2.50609 27.0998 2.4C27.0998 2.29391 27.0577 2.19217 26.9826 2.11716C26.9076 2.04214 26.8059 2 26.6998 2",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8999 2.7998H28.6999V2.3998C28.6999 2.29372 28.6578 2.19198 28.5827 2.11696C28.5077 2.04195 28.406 1.9998 28.2999 1.9998C28.1938 1.9998 28.0921 2.04195 28.0171 2.11696C27.942 2.19198 27.8999 2.29372 27.8999 2.3998",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4996 2.8C31.7205 2.8 31.8996 2.62091 31.8996 2.4C31.8996 2.17909 31.7205 2 31.4996 2C31.2787 2 31.0996 2.17909 31.0996 2.4C31.0996 2.62091 31.2787 2.8 31.4996 2.8Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8999 3.6001V2.8001H11.0999V3.2001C11.0999 3.30618 11.142 3.40793 11.2171 3.48294C11.2921 3.55795 11.3938 3.6001 11.4999 3.6001",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8999 2.7998V3.5998H12.6999V3.1998C12.6999 3.09372 12.6578 2.99198 12.5827 2.91696C12.5077 2.84195 12.406 2.7998 12.2999 2.7998",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 2.7998H13.4998V3.1998C13.4998 3.30589 13.5419 3.40763 13.617 3.48265C13.692 3.55766 13.7937 3.5998 13.8998 3.5998C14.0059 3.5998 14.1076 3.55766 14.1826 3.48265C14.2577 3.40763 14.2998 3.30589 14.2998 3.1998",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 3.6001H15.8996V3.2001C15.8996 3.09401 15.8575 2.99227 15.7825 2.91725C15.7074 2.84224 15.6057 2.8001 15.4996 2.8001C15.3935 2.8001 15.2918 2.84224 15.2168 2.91725C15.1418 2.99227 15.0996 3.09401 15.0996 3.2001",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 2.7998H19.8999V3.5998H20.6999V2.7998Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 2.7998H20.6997V3.5998H21.4997V2.7998Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2999 3.5998C24.5208 3.5998 24.6999 3.42072 24.6999 3.1998C24.6999 2.97889 24.5208 2.7998 24.2999 2.7998C24.079 2.7998 23.8999 2.97889 23.8999 3.1998C23.8999 3.42072 24.079 3.5998 24.2999 3.5998Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 2.7998H25.4995V3.5998H26.2995V2.7998Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 3.6001H27.8996V2.8001H27.4996C27.3935 2.8001 27.2918 2.84224 27.2168 2.91725C27.1418 2.99227 27.0996 3.09401 27.0996 3.2001",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 2.7998H27.8997V3.5998H28.2997C28.4058 3.5998 28.5075 3.55766 28.5825 3.48265C28.6576 3.40763 28.6997 3.30589 28.6997 3.1998",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 3.6001H31.0998V3.2001C31.0998 3.09401 31.0577 2.99227 30.9826 2.91725C30.9076 2.84224 30.8059 2.8001 30.6998 2.8001C30.5937 2.8001 30.492 2.84224 30.417 2.91725C30.3419 2.99227 30.2998 3.09401 30.2998 3.2001",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 4.3999H9.49971V3.9999C9.49971 3.89382 9.45756 3.79207 9.38255 3.71706C9.30753 3.64204 9.20579 3.5999 9.09971 3.5999C8.99362 3.5999 8.89188 3.64204 8.81686 3.71706C8.74185 3.79207 8.69971 3.89382 8.69971 3.9999",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6998 4.4001C10.9207 4.4001 11.0998 4.22101 11.0998 4.0001C11.0998 3.77918 10.9207 3.6001 10.6998 3.6001C10.4789 3.6001 10.2998 3.77918 10.2998 4.0001C10.2998 4.22101 10.4789 4.4001 10.6998 4.4001Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 4.3999V3.5999H11.8997V3.9999C11.8997 4.10599 11.9418 4.20773 12.0169 4.28275C12.0919 4.35776 12.1936 4.3999 12.2997 4.3999",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 3.6001V4.4001H13.4997V4.0001C13.4997 3.89401 13.4576 3.79227 13.3826 3.71725C13.3075 3.64224 13.2058 3.6001 13.0997 3.6001",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 4.3999H15.0998V3.5999H14.6998C14.5937 3.5999 14.492 3.64204 14.417 3.71706C14.3419 3.79207 14.2998 3.89382 14.2998 3.9999",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 3.6001H15.0999V4.4001H15.4999C15.606 4.4001 15.7077 4.35796 15.7827 4.28294C15.8578 4.20793 15.8999 4.10618 15.8999 4.0001",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8995 4.4001C18.1204 4.4001 18.2995 4.22101 18.2995 4.0001C18.2995 3.77918 18.1204 3.6001 17.8995 3.6001C17.6786 3.6001 17.4995 3.77918 17.4995 4.0001C17.4995 4.22101 17.6786 4.4001 17.8995 4.4001Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0996 4.3999H19.8996V3.5999H19.4996C19.3935 3.5999 19.2918 3.64204 19.2168 3.71706C19.1418 3.79207 19.0996 3.89382 19.0996 3.9999",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 3.6001H19.8999V4.4001H20.6999V3.6001Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 3.6001H20.6997V4.4001H21.4997V3.6001Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4995 3.6001V4.4001H22.2995V4.0001C22.2995 3.89401 22.2574 3.79227 22.1824 3.71725C22.1073 3.64224 22.0056 3.6001 21.8995 3.6001",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6997 4.3999H25.4997V3.5999H25.0997C24.9936 3.5999 24.8919 3.64204 24.8169 3.71706C24.7418 3.79207 24.6997 3.89382 24.6997 3.9999",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 3.6001H25.4995V4.4001H26.2995V3.6001Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 3.6001H26.2998V4.4001H27.0998V3.6001Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 3.6001H27.0996V4.4001H27.8996V3.6001Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 3.6001H30.2998V4.4001H31.0998V3.6001Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 5.2002V4.4002H8.69951V4.8002C8.69951 4.90628 8.74165 5.00802 8.81667 5.08304C8.89168 5.15805 8.99343 5.2002 9.09951 5.2002",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 4.3999V5.1999H9.89951C10.0056 5.1999 10.1073 5.15776 10.1824 5.08274C10.2574 5.00773 10.2995 4.90599 10.2995 4.7999C10.2995 4.69382 10.2574 4.59207 10.1824 4.51706C10.1073 4.44205 10.0056 4.3999 9.89951 4.3999",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 5.2002H11.8996V4.8002C11.8996 4.69411 11.8575 4.59237 11.7825 4.51735C11.7074 4.44234 11.6057 4.4002 11.4996 4.4002C11.3935 4.4002 11.2918 4.44234 11.2168 4.51735C11.1418 4.59237 11.0996 4.69411 11.0996 4.8002",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 4.3999H12.6995V4.7999C12.6995 4.90599 12.7417 5.00773 12.8167 5.08275C12.8917 5.15776 12.9934 5.1999 13.0995 5.1999C13.2056 5.1999 13.3073 5.15776 13.3824 5.08275C13.4574 5.00773 13.4995 4.90599 13.4995 4.7999",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 4.3999H14.2996V4.7999C14.2996 4.90599 14.3418 5.00773 14.4168 5.08275C14.4918 5.15776 14.5935 5.1999 14.6996 5.1999C14.8057 5.1999 14.9074 5.15776 14.9825 5.08275C15.0575 5.00773 15.0996 4.90599 15.0996 4.7999",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 4.3999H19.0996V5.1999H19.8996V4.3999Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 4.3999H20.6997V5.1999H21.4997V4.3999Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 4.3999H21.4995V5.1999H22.2995V4.3999Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0998 4.3999H22.2998V5.1999H23.0998V4.3999Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 4.3999V5.1999H23.8996V4.7999C23.8996 4.69382 23.8575 4.59207 23.7825 4.51706C23.7074 4.44205 23.6057 4.3999 23.4996 4.3999",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 5.2002V4.4002H24.6995V4.8002C24.6995 4.90628 24.7417 5.00802 24.8167 5.08304C24.8917 5.15805 24.9934 5.2002 25.0995 5.2002",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 4.3999H25.4995V5.1999H26.2995V4.3999Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 4.3999H26.2998V5.1999H27.0998V4.3999Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8999 4.3999H27.0999V5.1999H27.4999C27.606 5.1999 27.7077 5.15776 27.7827 5.08275C27.8578 5.00773 27.8999 4.90599 27.8999 4.7999",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 5.2002H29.4997V4.8002C29.4997 4.69411 29.4576 4.59237 29.3825 4.51735C29.3075 4.44234 29.2058 4.4002 29.0997 4.4002C28.9936 4.4002 28.8919 4.44234 28.8169 4.51735C28.7418 4.59237 28.6997 4.69411 28.6997 4.8002",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 4.3999H30.2998V5.1999H31.0998V4.3999Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 4.3999V5.1999H31.8996V4.7999C31.8996 4.69382 31.8575 4.59207 31.7825 4.51706C31.7074 4.44205 31.6057 4.3999 31.4996 4.3999",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 6V5.2H10.6996C10.5935 5.2 10.4918 5.24214 10.4168 5.31716C10.3418 5.39217 10.2996 5.49391 10.2996 5.6C10.2996 5.70609 10.3418 5.80783 10.4168 5.88284C10.4918 5.95786 10.5935 6 10.6996 6",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 5.2002H11.0996V6.0002H11.8996V5.2002Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8999 5.2002V6.0002H12.6999V5.6002C12.6999 5.49411 12.6578 5.39237 12.5827 5.31735C12.5077 5.24234 12.406 5.2002 12.2999 5.2002",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 6H14.2995V5.6C14.2995 5.49391 14.2574 5.39217 14.1824 5.31716C14.1073 5.24214 14.0056 5.2 13.8995 5.2C13.7934 5.2 13.6917 5.24214 13.6167 5.31716C13.5417 5.39217 13.4995 5.49391 13.4995 5.6",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4996 6.0002C15.7205 6.0002 15.8996 5.82111 15.8996 5.6002C15.8996 5.37928 15.7205 5.2002 15.4996 5.2002C15.2787 5.2002 15.0996 5.37928 15.0996 5.6002C15.0996 5.82111 15.2787 6.0002 15.4996 6.0002Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 6V5.2H17.0995C16.9934 5.2 16.8917 5.24214 16.8167 5.31716C16.7417 5.39217 16.6995 5.49391 16.6995 5.6C16.6995 5.70609 16.7417 5.80783 16.8167 5.88284C16.8917 5.95786 16.9934 6 17.0995 6",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2995 5.2002H17.4995V6.0002H18.2995V5.2002Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 5.2002H18.2998V6.0002H19.0998V5.2002Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 5.2002H19.0996V6.0002H19.8996V5.2002Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 5.2002H19.8999V6.0002H20.6999V5.2002Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 5.2002H20.6997V6.0002H21.4997V5.2002Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 5.2002H21.4995V6.0002H22.2995V5.2002Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 6V5.2H23.0999V5.6C23.0999 5.70609 23.142 5.80783 23.2171 5.88284C23.2921 5.95786 23.3938 6 23.4999 6",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 5.2002V6.0002H24.2999C24.406 6.0002 24.5077 5.95805 24.5827 5.88304C24.6578 5.80802 24.6999 5.70628 24.6999 5.6002C24.6999 5.49411 24.6578 5.39237 24.5827 5.31735C24.5077 5.24234 24.406 5.2002 24.2999 5.2002",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2998 6V5.2H25.4998V5.6C25.4998 5.70609 25.5419 5.80783 25.617 5.88284C25.692 5.95786 25.7937 6 25.8998 6",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 5.2002H26.2996V6.0002H26.6996C26.8057 6.0002 26.9074 5.95805 26.9825 5.88304C27.0575 5.80802 27.0996 5.70628 27.0996 5.6002",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 6V5.2H28.6995V5.6C28.6995 5.70609 28.7417 5.80783 28.8167 5.88284C28.8917 5.95786 28.9934 6 29.0995 6",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 5.2002H29.4995V6.0002H30.2995V5.2002Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 5.2002H30.2998V6.0002H31.0998V5.2002Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8999 5.2002H31.0999V6.0002H31.4999C31.606 6.0002 31.7077 5.95805 31.7827 5.88304C31.8578 5.80802 31.8999 5.70628 31.8999 5.6002",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6999 6H11.8999V6.8H12.6999V6Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 6H12.6997V6.8H13.4997V6Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 6H13.4995V6.8H14.2995V6Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2999 6.8C16.5208 6.8 16.6999 6.62091 16.6999 6.4C16.6999 6.17909 16.5208 6 16.2999 6C16.079 6 15.8999 6.17909 15.8999 6.4C15.8999 6.62091 16.079 6.8 16.2999 6.8Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 6H18.2998V6.8H19.0998V6Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 6H21.4995V6.8H22.2995V6Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2998 6V6.8H22.6998C22.8059 6.8 22.9076 6.75786 22.9826 6.68284C23.0577 6.60783 23.0998 6.50609 23.0998 6.4C23.0998 6.29391 23.0577 6.19217 22.9826 6.11716C22.9076 6.04214 22.8059 6 22.6998 6",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6997 6.7998H25.4997V6.3998C25.4997 6.29372 25.4576 6.19198 25.3825 6.11696C25.3075 6.04195 25.2058 5.9998 25.0997 5.9998C24.9936 5.9998 24.8919 6.04195 24.8169 6.11696C24.7418 6.19198 24.6997 6.29372 24.6997 6.3998",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8999 6.7998V5.9998H27.4999C27.3938 5.9998 27.2921 6.04195 27.2171 6.11696C27.142 6.19198 27.0999 6.29372 27.0999 6.3998C27.0999 6.50589 27.142 6.60763 27.2171 6.68265C27.2921 6.75766 27.3938 6.7998 27.4999 6.7998",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8999 6V6.8H28.6999V6.4C28.6999 6.29391 28.6578 6.19217 28.5827 6.11716C28.5077 6.04214 28.406 6 28.2999 6",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09971 7.5998C9.32062 7.5998 9.49971 7.42072 9.49971 7.1998C9.49971 6.97889 9.32062 6.7998 9.09971 6.7998C8.87879 6.7998 8.69971 6.97889 8.69971 7.1998C8.69971 7.42072 8.87879 7.5998 9.09971 7.5998Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2998 7.6001H11.0998V7.2001C11.0998 7.09401 11.0577 6.99227 10.9826 6.91725C10.9076 6.84224 10.8059 6.8001 10.6998 6.8001C10.5937 6.8001 10.492 6.84224 10.417 6.91725C10.3419 6.99227 10.2998 7.09401 10.2998 7.2001",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6999 6.7998H11.8999V7.5998H12.6999V6.7998Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 6.7998H13.4995V7.5998H14.2995V6.7998Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4996 7.5998C15.7205 7.5998 15.8996 7.42072 15.8996 7.1998C15.8996 6.97889 15.7205 6.7998 15.4996 6.7998C15.2787 6.7998 15.0996 6.97889 15.0996 7.1998C15.0996 7.42072 15.2787 7.5998 15.4996 7.5998Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 7.6001H17.4997V7.2001C17.4997 7.09401 17.4576 6.99227 17.3825 6.91725C17.3075 6.84224 17.2058 6.8001 17.0997 6.8001C16.9936 6.8001 16.8919 6.84224 16.8169 6.91725C16.7418 6.99227 16.6997 7.09401 16.6997 7.2001",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 6.7998H18.2998V7.5998H19.0998V6.7998Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2999 7.5998C20.5208 7.5998 20.6999 7.42072 20.6999 7.1998C20.6999 6.97889 20.5208 6.7998 20.2999 6.7998C20.079 6.7998 19.8999 6.97889 19.8999 7.1998C19.8999 7.42072 20.079 7.5998 20.2999 7.5998Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 6.7998H21.4995V7.5998H22.2995V6.7998Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 7.6001H23.8996V7.2001C23.8996 7.09401 23.8575 6.99227 23.7825 6.91725C23.7074 6.84224 23.6057 6.8001 23.4996 6.8001C23.3935 6.8001 23.2918 6.84224 23.2168 6.91725C23.1418 6.99227 23.0996 7.09401 23.0996 7.2001",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 6.7998H24.6995V7.1998C24.6995 7.30589 24.7417 7.40763 24.8167 7.48265C24.8917 7.55766 24.9934 7.5998 25.0995 7.5998C25.2056 7.5998 25.3073 7.55766 25.3824 7.48265C25.4574 7.40763 25.4995 7.30589 25.4995 7.1998",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2998 7.6001H27.0998V7.2001C27.0998 7.09401 27.0577 6.99227 26.9826 6.91725C26.9076 6.84224 26.8059 6.8001 26.6998 6.8001C26.5937 6.8001 26.492 6.84224 26.417 6.91725C26.3419 6.99227 26.2998 7.09401 26.2998 7.2001",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 6.7998H27.8999V7.5998H28.6999V6.7998Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 7.6001H30.2995V7.2001C30.2995 7.09401 30.2574 6.99227 30.1824 6.91725C30.1073 6.84224 30.0056 6.8001 29.8995 6.8001C29.7934 6.8001 29.6917 6.84224 29.6167 6.91725C29.5417 6.99227 29.4995 7.09401 29.4995 7.2001",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4996 7.5998C31.7205 7.5998 31.8996 7.42072 31.8996 7.1998C31.8996 6.97889 31.7205 6.7998 31.4996 6.7998C31.2787 6.7998 31.0996 6.97889 31.0996 7.1998C31.0996 7.42072 31.2787 7.5998 31.4996 7.5998Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 8.3999V7.5999H10.2996V7.9999C10.2996 8.10599 10.3418 8.20773 10.4168 8.28274C10.4918 8.35776 10.5935 8.3999 10.6996 8.3999",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 7.6001H11.0996V8.4001H11.8996V7.6001Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 7.6001H11.8997V8.4001H12.2997C12.4058 8.4001 12.5075 8.35796 12.5825 8.28294C12.6576 8.20793 12.6997 8.10618 12.6997 8.0001",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 7.6001H13.4998V8.0001C13.4998 8.10618 13.5419 8.20793 13.617 8.28294C13.692 8.35796 13.7937 8.4001 13.8998 8.4001C14.0059 8.4001 14.1076 8.35796 14.1826 8.28294C14.2577 8.20793 14.2998 8.10618 14.2998 8.0001",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 8.3999V7.5999H16.2997C16.1936 7.5999 16.0919 7.64205 16.0169 7.71706C15.9418 7.79207 15.8997 7.89382 15.8997 7.9999C15.8997 8.10599 15.9418 8.20773 16.0169 8.28274C16.0919 8.35776 16.1936 8.3999 16.2997 8.3999",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 7.6001H16.6995V8.4001H17.0995C17.2056 8.4001 17.3073 8.35796 17.3824 8.28294C17.4574 8.20793 17.4995 8.10618 17.4995 8.0001",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 7.6001H18.2998V8.4001H19.0998V7.6001Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 7.6001H21.4995V8.4001H22.2995V7.6001Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 7.6001H23.0999V8.0001C23.0999 8.10618 23.142 8.20793 23.2171 8.28294C23.2921 8.35796 23.3938 8.4001 23.4999 8.4001C23.606 8.4001 23.7077 8.35796 23.7827 8.28294C23.8578 8.20793 23.8999 8.10618 23.8999 8.0001",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2998 8.3999V7.5999H25.8998C25.7937 7.5999 25.692 7.64205 25.617 7.71706C25.5419 7.79207 25.4998 7.89382 25.4998 7.9999C25.4998 8.10599 25.5419 8.20773 25.617 8.28274C25.692 8.35776 25.7937 8.3999 25.8998 8.3999",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 7.6001H26.2998V8.4001H27.0998V7.6001Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 7.6001H27.8997V8.0001C27.8997 8.10618 27.9418 8.20793 28.0169 8.28294C28.0919 8.35796 28.1936 8.4001 28.2997 8.4001C28.4058 8.4001 28.5075 8.35796 28.5825 8.28294C28.6576 8.20793 28.6997 8.10618 28.6997 8.0001",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 7.6001H29.4995V8.4001H30.2995V7.6001Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 7.6001V8.4001H31.0998V8.0001C31.0998 7.89401 31.0577 7.79227 30.9826 7.71726C30.9076 7.64224 30.8059 7.6001 30.6998 7.6001",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 9.2002V8.4002H5.09951C4.99343 8.4002 4.89168 8.44234 4.81667 8.51735C4.74165 8.59237 4.69951 8.69411 4.69951 8.8002C4.69951 8.90628 4.74165 9.00802 4.81667 9.08304C4.89168 9.15805 4.99343 9.2002 5.09951 9.2002",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 8.3999V9.1999H6.29951V8.7999C6.29951 8.69382 6.25737 8.59207 6.18235 8.51706C6.10734 8.44205 6.0056 8.3999 5.89951 8.3999",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8999 9.2002V8.4002H7.4999C7.39382 8.4002 7.29207 8.44234 7.21706 8.51735C7.14205 8.59237 7.0999 8.69411 7.0999 8.8002C7.0999 8.90628 7.14205 9.00802 7.21706 9.08304C7.29207 9.15805 7.39382 9.2002 7.4999 9.2002",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8999 8.3999V9.1999H8.2999C8.40599 9.1999 8.50773 9.15776 8.58274 9.08275C8.65776 9.00773 8.6999 8.90599 8.6999 8.7999C8.6999 8.69382 8.65776 8.59207 8.58274 8.51706C8.50773 8.44205 8.40599 8.3999 8.2999 8.3999",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2998 9.2002V8.4002H17.8998C17.7937 8.4002 17.692 8.44234 17.617 8.51735C17.5419 8.59237 17.4998 8.69411 17.4998 8.8002C17.4998 8.90628 17.5419 9.00802 17.617 9.08304C17.692 9.15805 17.7937 9.2002 17.8998 9.2002",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 8.3999H18.2998V9.1999H19.0998V8.3999Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 8.3999H19.0996V9.1999H19.8996V8.3999Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 8.3999H19.8999V9.1999H20.6999V8.3999Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 8.3999H20.6997V9.1999H21.4997V8.3999Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 8.3999H21.4995V9.1999H22.2995V8.3999Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2998 8.3999V9.1999H23.0998V8.7999C23.0998 8.69382 23.0577 8.59207 22.9826 8.51706C22.9076 8.44205 22.8059 8.3999 22.6998 8.3999",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2999 9.1999C24.5208 9.1999 24.6999 9.02082 24.6999 8.7999C24.6999 8.57899 24.5208 8.3999 24.2999 8.3999C24.079 8.3999 23.8999 8.57899 23.8999 8.7999C23.8999 9.02082 24.079 9.1999 24.2999 9.1999Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 8.3999H26.2998V9.1999H27.0998V8.3999Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 8.3999V9.1999H27.8996V8.7999C27.8996 8.69382 27.8575 8.59207 27.7825 8.51706C27.7074 8.44205 27.6057 8.3999 27.4996 8.3999",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 8.3999H29.4995V9.1999H30.2995V8.3999Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 8.3999H30.2998V9.1999H31.0998V8.3999Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 8.3999V9.1999H31.8996V8.7999C31.8996 8.69382 31.8575 8.59207 31.7825 8.51706C31.7074 8.44205 31.6057 8.3999 31.4996 8.3999",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0996 9.2002H35.8996V8.4002H35.4996C35.3935 8.4002 35.2918 8.44234 35.2168 8.51735C35.1418 8.59237 35.0996 8.69411 35.0996 8.8002",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8999 8.3999V9.1999H36.2999C36.406 9.1999 36.5077 9.15776 36.5827 9.08275C36.6578 9.00773 36.6999 8.90599 36.6999 8.7999C36.6999 8.69382 36.6578 8.59207 36.5827 8.51706C36.5077 8.44205 36.406 8.3999 36.2999 8.3999",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 10V9.2H2.69961C2.59352 9.2 2.49178 9.24214 2.41677 9.31716C2.34175 9.39217 2.29961 9.49391 2.29961 9.6C2.29961 9.70609 2.34175 9.80783 2.41677 9.88284C2.49178 9.95786 2.59352 10 2.69961 10",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 9.2002V10.0002H3.49961C3.6057 10.0002 3.70744 9.95805 3.78245 9.88304C3.85747 9.80802 3.89961 9.70628 3.89961 9.6002C3.89961 9.49411 3.85747 9.39237 3.78245 9.31735C3.70744 9.24234 3.6057 9.2002 3.49961 9.2002",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2998 9.2002H5.4998V9.6002C5.4998 9.70628 5.54195 9.80802 5.61696 9.88304C5.69198 9.95805 5.79372 10.0002 5.8998 10.0002C6.00589 10.0002 6.10763 9.95805 6.18265 9.88304C6.25766 9.80802 6.2998 9.70628 6.2998 9.6002",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2998 10H11.0998V9.2H10.6998C10.5937 9.2 10.492 9.24214 10.417 9.31716C10.3419 9.39217 10.2998 9.49391 10.2998 9.6",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 9.2002H11.0996V10.0002H11.8996V9.2002Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8999 9.2002V10.0002H12.6999V9.6002C12.6999 9.49411 12.6578 9.39237 12.5827 9.31735C12.5077 9.24234 12.406 9.2002 12.2999 9.2002",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 10H15.0998V9.2H14.6998C14.5937 9.2 14.492 9.24214 14.417 9.31716C14.3419 9.39217 14.2998 9.49391 14.2998 9.6",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 9.2002V10.0002H15.4996C15.6057 10.0002 15.7074 9.95805 15.7825 9.88304C15.8575 9.80802 15.8996 9.70628 15.8996 9.6002C15.8996 9.49411 15.8575 9.39237 15.7825 9.31735C15.7074 9.24234 15.6057 9.2002 15.4996 9.2002",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8999 9.2002H19.0999V9.6002C19.0999 9.70628 19.142 9.80802 19.2171 9.88304C19.2921 9.95805 19.3938 10.0002 19.4999 10.0002C19.606 10.0002 19.7077 9.95805 19.7827 9.88304C19.8578 9.80802 19.8999 9.70628 19.8999 9.6002",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0998 9.2002H22.2998V10.0002H23.0998V9.2002Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 9.2002V10.0002H23.8996V9.6002C23.8996 9.49411 23.8575 9.39237 23.7825 9.31735C23.7074 9.24234 23.6057 9.2002 23.4996 9.2002",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 10V9.2H26.2996V9.6C26.2996 9.70609 26.3418 9.80783 26.4168 9.88284C26.4918 9.95786 26.5935 10 26.6996 10",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 9.2002H27.0996V10.0002H27.8996V9.2002Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 9.2002H27.8999V10.0002H28.6999V9.2002Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 9.2002H28.6997V10.0002H29.4997V9.2002Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 9.2002H29.4998V10.0002H29.8998C30.0059 10.0002 30.1076 9.95805 30.1826 9.88304C30.2577 9.80802 30.2998 9.70628 30.2998 9.6002",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 9.2002H31.0996V10.0002H31.8996V9.2002Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6997 10H33.4997V9.2H33.0997C32.9936 9.2 32.8919 9.24214 32.8169 9.31716C32.7418 9.39217 32.6997 9.49391 32.6997 9.6",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 9.2002H33.4995V10.0002H34.2995V9.2002Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 9.2002H34.2998V10.0002H35.0998V9.2002Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 9.2002H35.0996V10.0002H35.8996V9.2002Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 10H38.2995V9.6C38.2995 9.49391 38.2574 9.39217 38.1824 9.31716C38.1073 9.24214 38.0056 9.2 37.8995 9.2C37.7934 9.2 37.6917 9.24214 37.6167 9.31716C37.5417 9.39217 37.4995 9.49391 37.4995 9.6",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2998 10.7998H7.0998V9.9998H6.6998C6.59372 9.9998 6.49198 10.0419 6.41696 10.117C6.34195 10.192 6.2998 10.2937 6.2998 10.3998",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09961 10V10.8H7.49961C7.6057 10.8 7.70744 10.7579 7.78245 10.6828C7.85747 10.6078 7.89961 10.5061 7.89961 10.4C7.89961 10.2939 7.85747 10.1922 7.78245 10.1172C7.70744 10.0421 7.6057 10 7.49961 10",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 10.7998H9.49971V9.9998H9.09971C8.99362 9.9998 8.89188 10.0419 8.81686 10.117C8.74185 10.192 8.69971 10.2937 8.69971 10.3998",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 10H9.49951V10.8H10.2995V10Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 10H10.2998V10.8H11.0998V10Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 10.7998V9.9998H11.8997V10.3998C11.8997 10.5059 11.9418 10.6076 12.0169 10.6826C12.0919 10.7577 12.1936 10.7998 12.2997 10.7998",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 10H12.6997V10.8H13.4997V10Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 10H13.4995V10.8H14.2995V10Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 10H14.2996V10.8H14.6996C14.8057 10.8 14.9074 10.7579 14.9825 10.6828C15.0575 10.6078 15.0996 10.5061 15.0996 10.4",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 10.7998V9.9998H16.2997C16.1936 9.9998 16.0919 10.0419 16.0169 10.117C15.9418 10.192 15.8997 10.2937 15.8997 10.3998C15.8997 10.5059 15.9418 10.6076 16.0169 10.6826C16.0919 10.7577 16.1936 10.7998 16.2997 10.7998",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 10V10.8H17.0997C17.2058 10.8 17.3075 10.7579 17.3826 10.6828C17.4576 10.6078 17.4997 10.5061 17.4997 10.4C17.4997 10.2939 17.4576 10.1922 17.3826 10.1172C17.3075 10.0421 17.2058 10 17.0997 10",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8999 10.7998H20.6999V9.9998H20.2999C20.1938 9.9998 20.0921 10.0419 20.0171 10.117C19.942 10.192 19.8999 10.2937 19.8999 10.3998",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6997 10V10.8H21.0997C21.2058 10.8 21.3075 10.7579 21.3826 10.6828C21.4576 10.6078 21.4997 10.5061 21.4997 10.4C21.4997 10.2939 21.4576 10.1922 21.3826 10.1172C21.3075 10.0421 21.2058 10 21.0997 10",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 10.7998V9.9998H22.2996V10.3998C22.2996 10.5059 22.3418 10.6076 22.4168 10.6826C22.4918 10.7577 22.5935 10.7998 22.6996 10.7998",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 10H23.0999V10.8H23.4999C23.606 10.8 23.7077 10.7579 23.7827 10.6828C23.8578 10.6078 23.8999 10.5061 23.8999 10.4",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6997 10.7998H25.4997V9.9998H25.0997C24.9936 9.9998 24.8919 10.0419 24.8169 10.117C24.7418 10.192 24.6997 10.2937 24.6997 10.3998",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 10V10.8H25.8995C26.0056 10.8 26.1073 10.7579 26.1824 10.6828C26.2574 10.6078 26.2995 10.5061 26.2995 10.4C26.2995 10.2939 26.2574 10.1922 26.1824 10.1172C26.1073 10.0421 26.0056 10 25.8995 10",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 10.7998V9.9998H27.8997V10.3998C27.8997 10.5059 27.9418 10.6076 28.0169 10.6826C28.0919 10.7577 28.1936 10.7998 28.2997 10.7998",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 10H28.6995V10.8H29.0995C29.2056 10.8 29.3073 10.7579 29.3824 10.6828C29.4574 10.6078 29.4995 10.5061 29.4995 10.4",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 10H31.0996V10.8H31.8996V10Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 10H31.8999V10.8H32.6999V10Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 10H32.6997V10.8H33.4997V10Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2998 10H33.4998V10.8H33.8998C34.0059 10.8 34.1076 10.7579 34.1826 10.6828C34.2577 10.6078 34.2998 10.5061 34.2998 10.4",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8999 10H35.0999V10.4C35.0999 10.5061 35.142 10.6078 35.2171 10.6828C35.2921 10.7579 35.3938 10.8 35.4999 10.8C35.606 10.8 35.7077 10.7579 35.7827 10.6828C35.8578 10.6078 35.8999 10.5061 35.8999 10.4",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2998 10H37.4998V10.4C37.4998 10.5061 37.5419 10.6078 37.617 10.6828C37.692 10.7579 37.7937 10.8 37.8998 10.8C38.0059 10.8 38.1076 10.7579 38.1826 10.6828C38.2577 10.6078 38.2998 10.5061 38.2998 10.4",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 11.6001H3.89961V11.2001C3.89961 11.094 3.85747 10.9923 3.78245 10.9173C3.70744 10.8422 3.6057 10.8001 3.49961 10.8001C3.39352 10.8001 3.29178 10.8422 3.21677 10.9173C3.14175 10.9923 3.09961 11.094 3.09961 11.2001",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2998 11.6001V10.8001H5.8998C5.79372 10.8001 5.69198 10.8422 5.61696 10.9173C5.54195 10.9923 5.4998 11.094 5.4998 11.2001C5.4998 11.3062 5.54195 11.4079 5.61696 11.4829C5.69198 11.558 5.79372 11.6001 5.8998 11.6001",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 10.7998H6.2998V11.5998H7.0998V10.7998Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8999 11.6001H8.6999V10.8001H8.2999C8.19382 10.8001 8.09207 10.8422 8.01706 10.9173C7.94204 10.9923 7.8999 11.094 7.8999 11.2001",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 10.7998H8.69971V11.5998H9.49971V10.7998Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 10.7998H9.49951V11.5998H10.2995V10.7998Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 10.7998H10.2998V11.5998H11.0998V10.7998Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 10.7998V11.5998H11.4996C11.6057 11.5998 11.7074 11.5577 11.7825 11.4826C11.8575 11.4076 11.8996 11.3059 11.8996 11.1998C11.8996 11.0937 11.8575 10.992 11.7825 10.917C11.7074 10.8419 11.6057 10.7998 11.4996 10.7998",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 10.7998H12.6997V11.5998H13.4997V10.7998Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8999 11.6001V10.8001H19.4999C19.3938 10.8001 19.2921 10.8422 19.2171 10.9173C19.142 10.9923 19.0999 11.094 19.0999 11.2001C19.0999 11.3062 19.142 11.4079 19.2171 11.4829C19.2921 11.558 19.3938 11.6001 19.4999 11.6001",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 10.7998H19.8999V11.5998H20.6999V10.7998Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 10.7998H24.6997V11.5998H25.4997V10.7998Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 11.6001V10.8001H29.8998C29.7937 10.8001 29.692 10.8422 29.617 10.9173C29.5419 10.9923 29.4998 11.094 29.4998 11.2001C29.4998 11.3062 29.5419 11.4079 29.617 11.4829C29.692 11.558 29.7937 11.6001 29.8998 11.6001",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 10.7998H30.2998V11.5998H31.0998V10.7998Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8999 10.7998H31.0999V11.5998H31.4999C31.606 11.5998 31.7077 11.5577 31.7827 11.4826C31.8578 11.4076 31.8999 11.3059 31.8999 11.1998",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6998 11.5998C34.9207 11.5998 35.0998 11.4207 35.0998 11.1998C35.0998 10.9789 34.9207 10.7998 34.6998 10.7998C34.4789 10.7998 34.2998 10.9789 34.2998 11.1998C34.2998 11.4207 34.4789 11.5998 34.6998 11.5998Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0997 11.5998C37.3206 11.5998 37.4997 11.4207 37.4997 11.1998C37.4997 10.9789 37.3206 10.7998 37.0997 10.7998C36.8788 10.7998 36.6997 10.9789 36.6997 11.1998C36.6997 11.4207 36.8788 11.5998 37.0997 11.5998Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 11.6001H3.09961V12.4001H3.89961V11.6001Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69971 12.3999H5.49971V11.9999C5.49971 11.8938 5.45756 11.7921 5.38255 11.7171C5.30754 11.642 5.20579 11.5999 5.09971 11.5999C4.99362 11.5999 4.89188 11.642 4.81686 11.7171C4.74185 11.7921 4.69971 11.8938 4.69971 11.9999",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09961 12.3999V11.5999H6.29961V11.9999C6.29961 12.106 6.34175 12.2077 6.41677 12.2827C6.49178 12.3578 6.59352 12.3999 6.69961 12.3999",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 11.6001H7.09961V12.4001H7.89961V11.6001Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6999 11.6001H7.8999V12.4001H8.6999V11.6001Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 11.6001H9.49951V12.4001H10.2995V11.6001Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 11.6001H10.2998V12.4001H11.0998V11.6001Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 11.6001H12.6997V12.4001H13.4997V11.6001Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 11.6001V12.4001H14.2995V12.0001C14.2995 11.894 14.2574 11.7923 14.1824 11.7173C14.1073 11.6422 14.0056 11.6001 13.8995 11.6001",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 12.3999H18.2995V11.5999H17.8995C17.7934 11.5999 17.6917 11.642 17.6167 11.7171C17.5417 11.7921 17.4995 11.8938 17.4995 11.9999",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2998 11.6001V12.4001H19.0998V12.0001C19.0998 11.894 19.0577 11.7923 18.9826 11.7173C18.9076 11.6422 18.8059 11.6001 18.6998 11.6001",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6997 11.6001H19.8997V12.0001C19.8997 12.1062 19.9418 12.2079 20.0169 12.2829C20.0919 12.358 20.1936 12.4001 20.2997 12.4001C20.4058 12.4001 20.5075 12.358 20.5826 12.2829C20.6576 12.2079 20.6997 12.1062 20.6997 12.0001",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 12.3999V11.5999H22.6996C22.5935 11.5999 22.4918 11.642 22.4168 11.7171C22.3418 11.7921 22.2996 11.8938 22.2996 11.9999C22.2996 12.106 22.3418 12.2077 22.4168 12.2827C22.4918 12.3578 22.5935 12.3999 22.6996 12.3999",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8996 11.6001H23.0996V12.4001H23.8996V11.6001Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 11.6001H23.8999V12.4001H24.6999V11.6001Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 11.6001H24.6997V12.4001H25.4997V11.6001Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 11.6001V12.4001H26.2995V12.0001C26.2995 11.894 26.2574 11.7923 26.1824 11.7173C26.1073 11.6422 26.0056 11.6001 25.8995 11.6001",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 12.3999V11.5999H28.2997C28.1936 11.5999 28.0919 11.642 28.0169 11.7171C27.9418 11.7921 27.8997 11.8938 27.8997 11.9999C27.8997 12.106 27.9418 12.2077 28.0169 12.2827C28.0919 12.3578 28.1936 12.3999 28.2997 12.3999",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 11.6001V12.4001H29.0997C29.2058 12.4001 29.3075 12.358 29.3826 12.2829C29.4576 12.2079 29.4997 12.1062 29.4997 12.0001C29.4997 11.894 29.4576 11.7923 29.3826 11.7173C29.3075 11.6422 29.2058 11.6001 29.0997 11.6001",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8999 12.3999H32.6999V11.9999C32.6999 11.8938 32.6578 11.7921 32.5827 11.7171C32.5077 11.642 32.406 11.5999 32.2999 11.5999C32.1938 11.5999 32.0921 11.642 32.0171 11.7171C31.942 11.7921 31.8999 11.8938 31.8999 11.9999",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8999 12.3999V11.5999H35.4999C35.3938 11.5999 35.2921 11.642 35.2171 11.7171C35.142 11.7921 35.0999 11.8938 35.0999 11.9999C35.0999 12.106 35.142 12.2077 35.2171 12.2827C35.2921 12.3578 35.3938 12.3999 35.4999 12.3999",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8999 11.6001V12.4001H36.2999C36.406 12.4001 36.5077 12.358 36.5827 12.2829C36.6578 12.2079 36.6999 12.1062 36.6999 12.0001C36.6999 11.894 36.6578 11.7923 36.5827 11.7173C36.5077 11.6422 36.406 11.6001 36.2999 11.6001",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2998 13.2002H3.0998V12.4002H2.6998C2.59372 12.4002 2.49198 12.4423 2.41696 12.5174C2.34195 12.5924 2.2998 12.6941 2.2998 12.8002",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 12.3999H3.09961V13.1999H3.89961V12.3999Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6999 12.3999H3.8999V13.1999H4.6999V12.3999Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49971 12.3999H4.69971V13.1999H5.49971V12.3999Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 12.3999V13.1999H5.89951C6.0056 13.1999 6.10734 13.1578 6.18235 13.0827C6.25737 13.0077 6.29951 12.906 6.29951 12.7999C6.29951 12.6938 6.25737 12.5921 6.18235 12.5171C6.10734 12.442 6.0056 12.3999 5.89951 12.3999",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6999 12.3999H7.8999V13.1999H8.6999V12.3999Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 12.3999H8.69971V13.1999H9.49971V12.3999Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 12.3999H9.49951V13.1999H10.2995V12.3999Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 12.3999H10.2998V13.1999H11.0998V12.3999Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 12.3999V13.1999H11.8996V12.7999C11.8996 12.6938 11.8575 12.5921 11.7825 12.5171C11.7074 12.442 11.6057 12.3999 11.4996 12.3999",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 12.3999H12.6997V13.1999H13.4997V12.3999Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 12.3999H13.4995V13.1999H14.2995V12.3999Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 12.3999V13.1999H14.6998C14.8059 13.1999 14.9076 13.1578 14.9826 13.0827C15.0577 13.0077 15.0998 12.906 15.0998 12.7999C15.0998 12.6938 15.0577 12.5921 14.9826 12.5171C14.9076 12.442 14.8059 12.3999 14.6998 12.3999",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2998 13.2002V12.4002H17.4998V12.8002C17.4998 12.9063 17.5419 13.008 17.617 13.083C17.692 13.1581 17.7937 13.2002 17.8998 13.2002",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0996 12.3999H18.2996V13.1999H18.6996C18.8057 13.1999 18.9074 13.1578 18.9825 13.0827C19.0575 13.0077 19.0996 12.906 19.0996 12.7999",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 12.3999H23.0999V12.7999C23.0999 12.906 23.142 13.0077 23.2171 13.0827C23.2921 13.1578 23.3938 13.1999 23.4999 13.1999C23.606 13.1999 23.7077 13.1578 23.7827 13.0827C23.8578 13.0077 23.8999 12.906 23.8999 12.7999",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2998 12.3999H25.4998V12.7999C25.4998 12.906 25.5419 13.0077 25.617 13.0827C25.692 13.1578 25.7937 13.1999 25.8998 13.1999C26.0059 13.1999 26.1076 13.1578 26.1826 13.0827C26.2577 13.0077 26.2998 12.906 26.2998 12.7999",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8999 13.2002V12.4002H31.4999C31.3938 12.4002 31.2921 12.4423 31.2171 12.5174C31.142 12.5924 31.0999 12.6941 31.0999 12.8002C31.0999 12.9063 31.142 13.008 31.2171 13.083C31.2921 13.1581 31.3938 13.2002 31.4999 13.2002",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 12.3999H31.8999V13.1999H32.6999V12.3999Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6997 12.3999V13.1999H33.4997V12.7999C33.4997 12.6938 33.4576 12.5921 33.3826 12.5171C33.3075 12.442 33.2058 12.3999 33.0997 12.3999",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6998 13.1999C34.9207 13.1999 35.0998 13.0208 35.0998 12.7999C35.0998 12.579 34.9207 12.3999 34.6998 12.3999C34.4789 12.3999 34.2998 12.579 34.2998 12.7999C34.2998 13.0208 34.4789 13.1999 34.6998 13.1999Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 14V13.2H2.29961V13.6C2.29961 13.7061 2.34175 13.8078 2.41677 13.8828C2.49178 13.9579 2.59352 14 2.69961 14",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8999 13.2002H3.0999V14.0002H3.4999C3.60599 14.0002 3.70773 13.9581 3.78275 13.883C3.85776 13.808 3.8999 13.7063 3.8999 13.6002",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 13.2002H4.69951V13.6002C4.69951 13.7063 4.74165 13.808 4.81667 13.883C4.89168 13.9581 4.99343 14.0002 5.09951 14.0002C5.2056 14.0002 5.30734 13.9581 5.38235 13.883C5.45737 13.808 5.49951 13.7063 5.49951 13.6002",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09961 14V13.2H6.69961C6.59352 13.2 6.49178 13.2421 6.41677 13.3172C6.34175 13.3922 6.29961 13.4939 6.29961 13.6C6.29961 13.7061 6.34175 13.8078 6.41677 13.8828C6.49178 13.9579 6.59352 14 6.69961 14",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 13.2002H7.09961V14.0002H7.89961V13.2002Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 13.2002H7.89971V14.0002H8.29971C8.40579 14.0002 8.50754 13.9581 8.58255 13.883C8.65756 13.808 8.69971 13.7063 8.69971 13.6002",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8999 14V13.2H11.0999V13.6C11.0999 13.7061 11.142 13.8078 11.2171 13.8828C11.2921 13.9579 11.3938 14 11.4999 14",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6999 13.2002H11.8999V14.0002H12.6999V13.2002Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 13.2002H12.6997V14.0002H13.4997V13.2002Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 14H16.6999V13.2H16.2999C16.1938 13.2 16.0921 13.2421 16.0171 13.3172C15.942 13.3922 15.8999 13.4939 15.8999 13.6",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 13.2002V14.0002H17.4997V13.6002C17.4997 13.4941 17.4576 13.3924 17.3826 13.3174C17.3075 13.2423 17.2058 13.2002 17.0997 13.2002",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8999 14V13.2H19.4999C19.3938 13.2 19.2921 13.2421 19.2171 13.3172C19.142 13.3922 19.0999 13.4939 19.0999 13.6C19.0999 13.7061 19.142 13.8078 19.2171 13.8828C19.2921 13.9579 19.3938 14 19.4999 14",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8999 13.2002V14.0002H20.2999C20.406 14.0002 20.5077 13.9581 20.5827 13.883C20.6578 13.808 20.6999 13.7063 20.6999 13.6002C20.6999 13.4941 20.6578 13.3924 20.5827 13.3174C20.5077 13.2423 20.406 13.2002 20.2999 13.2002",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6998 14.0002C22.9207 14.0002 23.0998 13.8211 23.0998 13.6002C23.0998 13.3793 22.9207 13.2002 22.6998 13.2002C22.4789 13.2002 22.2998 13.3793 22.2998 13.6002C22.2998 13.8211 22.4789 14.0002 22.6998 14.0002Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 14H24.6999V13.6C24.6999 13.4939 24.6578 13.3922 24.5827 13.3172C24.5077 13.2421 24.406 13.2 24.2999 13.2C24.1938 13.2 24.0921 13.2421 24.0171 13.3172C23.942 13.3922 23.8999 13.4939 23.8999 13.6",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2998 14H27.0998V13.2H26.6998C26.5937 13.2 26.492 13.2421 26.417 13.3172C26.3419 13.3922 26.2998 13.4939 26.2998 13.6",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 13.2002V14.0002H27.8996V13.6002C27.8996 13.4941 27.8575 13.3924 27.7825 13.3174C27.7074 13.2423 27.6057 13.2002 27.4996 13.2002",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4995 13.2002H32.6995V13.6002C32.6995 13.7063 32.7417 13.808 32.8167 13.883C32.8917 13.9581 32.9934 14.0002 33.0995 14.0002C33.2056 14.0002 33.3073 13.9581 33.3824 13.883C33.4574 13.808 33.4995 13.7063 33.4995 13.6002",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4996 14.0002C35.7205 14.0002 35.8996 13.8211 35.8996 13.6002C35.8996 13.3793 35.7205 13.2002 35.4996 13.2002C35.2787 13.2002 35.0996 13.3793 35.0996 13.6002C35.0996 13.8211 35.2787 14.0002 35.4996 14.0002Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0997 14.0002C37.3206 14.0002 37.4997 13.8211 37.4997 13.6002C37.4997 13.3793 37.3206 13.2002 37.0997 13.2002C36.8788 13.2002 36.6997 13.3793 36.6997 13.6002C36.6997 13.8211 36.8788 14.0002 37.0997 14.0002Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 14.7998H9.49971V13.9998H9.09971C8.99362 13.9998 8.89188 14.0419 8.81686 14.117C8.74185 14.192 8.69971 14.2937 8.69971 14.3998",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 14V14.8H10.2995V14.4C10.2995 14.2939 10.2574 14.1922 10.1824 14.1172C10.1073 14.0421 10.0056 14 9.89951 14",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 14H12.6997V14.8H13.4997V14Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 14.7998H15.8996V13.9998H15.4996C15.3935 13.9998 15.2918 14.0419 15.2168 14.117C15.1418 14.192 15.0996 14.2937 15.0996 14.3998",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6999 14H15.8999V14.8H16.6999V14Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 14H16.6995V14.8H17.0995C17.2056 14.8 17.3073 14.7579 17.3824 14.6828C17.4574 14.6078 17.4995 14.5061 17.4995 14.4",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6998 14.8C18.9207 14.8 19.0998 14.6209 19.0998 14.4C19.0998 14.1791 18.9207 14 18.6998 14C18.4789 14 18.2998 14.1791 18.2998 14.4C18.2998 14.6209 18.4789 14.8 18.6998 14.8Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4995 14.7998V13.9998H21.0995C20.9934 13.9998 20.8917 14.0419 20.8167 14.117C20.7417 14.192 20.6995 14.2937 20.6995 14.3998C20.6995 14.5059 20.7417 14.6076 20.8167 14.6826C20.8917 14.7577 20.9934 14.7998 21.0995 14.7998",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4995 14V14.8H22.2995V14.4C22.2995 14.2939 22.2574 14.1922 22.1824 14.1172C22.1073 14.0421 22.0056 14 21.8995 14",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 14.7998H23.8996V13.9998H23.4996C23.3935 13.9998 23.2918 14.0419 23.2168 14.117C23.1418 14.192 23.0996 14.2937 23.0996 14.3998",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 14H23.8999V14.8H24.6999V14Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 14H26.2998V14.8H27.0998V14Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8999 14H27.0999V14.8H27.4999C27.606 14.8 27.7077 14.7579 27.7827 14.6828C27.8578 14.6078 27.8999 14.5061 27.8999 14.4",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8999 14.7998V13.9998H31.4999C31.3938 13.9998 31.2921 14.0419 31.2171 14.117C31.142 14.192 31.0999 14.2937 31.0999 14.3998C31.0999 14.5059 31.142 14.6076 31.2171 14.6826C31.2921 14.7577 31.3938 14.7998 31.4999 14.7998",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8999 14V14.8H32.2999C32.406 14.8 32.5077 14.7579 32.5827 14.6828C32.6578 14.6078 32.6999 14.5061 32.6999 14.4C32.6999 14.2939 32.6578 14.1922 32.5827 14.1172C32.5077 14.0421 32.406 14 32.2999 14",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2999 14.8C36.5208 14.8 36.6999 14.6209 36.6999 14.4C36.6999 14.1791 36.5208 14 36.2999 14C36.079 14 35.8999 14.1791 35.8999 14.4C35.8999 14.6209 36.079 14.8 36.2999 14.8Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2998 15.6001H3.0998V15.2001C3.0998 15.094 3.05766 14.9923 2.98265 14.9173C2.90763 14.8422 2.80589 14.8001 2.6998 14.8001C2.59372 14.8001 2.49198 14.8422 2.41696 14.9173C2.34195 14.9923 2.2998 15.094 2.2998 15.2001",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69971 15.6001V14.8001H4.29971C4.19362 14.8001 4.09188 14.8422 4.01686 14.9173C3.94185 14.9923 3.89971 15.094 3.89971 15.2001C3.89971 15.3062 3.94185 15.4079 4.01686 15.4829C4.09188 15.558 4.19362 15.6001 4.29971 15.6001",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69971 14.7998V15.5998H5.09971C5.20579 15.5998 5.30753 15.5577 5.38255 15.4826C5.45756 15.4076 5.49971 15.3059 5.49971 15.1998C5.49971 15.0937 5.45756 14.992 5.38255 14.917C5.30753 14.8419 5.20579 14.7998 5.09971 14.7998",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8999 15.6001V14.8001H7.4999C7.39382 14.8001 7.29207 14.8422 7.21706 14.9173C7.14205 14.9923 7.0999 15.094 7.0999 15.2001C7.0999 15.3062 7.14205 15.4079 7.21706 15.4829C7.29207 15.558 7.39382 15.6001 7.4999 15.6001",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6999 14.7998H7.8999V15.5998H8.6999V14.7998Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 14.7998H8.69971V15.5998H9.49971V14.7998Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 14.7998H9.49951V15.5998H10.2995V14.7998Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 15.6001V14.8001H12.2997C12.1936 14.8001 12.0919 14.8422 12.0169 14.9173C11.9418 14.9923 11.8997 15.094 11.8997 15.2001C11.8997 15.3062 11.9418 15.4079 12.0169 15.4829C12.0919 15.558 12.1936 15.6001 12.2997 15.6001",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 14.7998H12.6995V15.5998H13.0995C13.2056 15.5998 13.3073 15.5577 13.3824 15.4826C13.4574 15.4076 13.4995 15.3059 13.4995 15.1998",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 14.7998H15.0996V15.5998H15.8996V14.7998Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 14.7998H15.8997V15.5998H16.2997C16.4058 15.5998 16.5075 15.5577 16.5826 15.4826C16.6576 15.4076 16.6997 15.3059 16.6997 15.1998",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0996 15.6001H19.8996V15.2001C19.8996 15.094 19.8575 14.9923 19.7825 14.9173C19.7074 14.8422 19.6057 14.8001 19.4996 14.8001C19.3935 14.8001 19.2918 14.8422 19.2168 14.9173C19.1418 14.9923 19.0996 15.094 19.0996 15.2001",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2998 14.7998H21.4998V15.1998C21.4998 15.3059 21.5419 15.4076 21.617 15.4826C21.692 15.5577 21.7937 15.5998 21.8998 15.5998C22.0059 15.5998 22.1076 15.5577 22.1826 15.4826C22.2577 15.4076 22.2998 15.3059 22.2998 15.1998",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 15.6001V14.8001H23.0999V15.2001C23.0999 15.3062 23.142 15.4079 23.2171 15.4829C23.2921 15.558 23.3938 15.6001 23.4999 15.6001",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 14.7998H23.8999V15.5998H24.6999V14.7998Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6997 14.7998V15.5998H25.4997V15.1998C25.4997 15.0937 25.4576 14.992 25.3826 14.917C25.3075 14.8419 25.2058 14.7998 25.0997 14.7998",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 14.7998H26.2998V15.5998H27.0998V14.7998Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8999 15.6001H28.6999V14.8001H28.2999C28.1938 14.8001 28.0921 14.8422 28.0171 14.9173C27.942 14.9923 27.8999 15.094 27.8999 15.2001",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 14.7998H28.6997V15.5998H29.4997V14.7998Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 14.7998H29.4995V15.5998H30.2995V14.7998Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 14.7998V15.5998H31.0998V15.1998C31.0998 15.0937 31.0577 14.992 30.9826 14.917C30.9076 14.8419 30.8059 14.7998 30.6998 14.7998",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4995 15.6001V14.8001H33.0995C32.9934 14.8001 32.8917 14.8422 32.8167 14.9173C32.7417 14.9923 32.6995 15.094 32.6995 15.2001C32.6995 15.3062 32.7417 15.4079 32.8167 15.4829C32.8917 15.558 32.9934 15.6001 33.0995 15.6001",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4995 14.7998V15.5998H33.8995C34.0056 15.5998 34.1073 15.5577 34.1824 15.4826C34.2574 15.4076 34.2995 15.3059 34.2995 15.1998C34.2995 15.0937 34.2574 14.992 34.1824 14.917C34.1073 14.8419 34.0056 14.7998 33.8995 14.7998",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4996 15.5998C35.7205 15.5998 35.8996 15.4207 35.8996 15.1998C35.8996 14.9789 35.7205 14.7998 35.4996 14.7998C35.2787 14.7998 35.0996 14.9789 35.0996 15.1998C35.0996 15.4207 35.2787 15.5998 35.4996 15.5998Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 15.6001H37.4997V15.2001C37.4997 15.094 37.4576 14.9923 37.3826 14.9173C37.3075 14.8422 37.2058 14.8001 37.0997 14.8001C36.9936 14.8001 36.8919 14.8422 36.8169 14.9173C36.7418 14.9923 36.6997 15.094 36.6997 15.2001",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 15.6001H2.29961V16.0001C2.29961 16.1062 2.34175 16.2079 2.41677 16.2829C2.49178 16.358 2.59352 16.4001 2.69961 16.4001C2.8057 16.4001 2.90744 16.358 2.98245 16.2829C3.05747 16.2079 3.09961 16.1062 3.09961 16.0001",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2998 16.3999H7.0998V15.9999C7.0998 15.8938 7.05766 15.7921 6.98265 15.7171C6.90763 15.642 6.80589 15.5999 6.6998 15.5999C6.59372 15.5999 6.49198 15.642 6.41696 15.7171C6.34195 15.7921 6.2998 15.8938 6.2998 15.9999",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 16.3999V15.5999H7.89971V15.9999C7.89971 16.106 7.94185 16.2077 8.01686 16.2827C8.09188 16.3578 8.19362 16.3999 8.29971 16.3999",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 15.6001H8.69971V16.4001H9.49971V15.6001Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 15.6001H9.49951V16.4001H10.2995V15.6001Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2998 15.6001V16.4001H11.0998V16.0001C11.0998 15.894 11.0577 15.7923 10.9826 15.7173C10.9076 15.6422 10.8059 15.6001 10.6998 15.6001",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 15.6001H15.0996V16.4001H15.8996V15.6001Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 16.3999V15.5999H17.0995C16.9934 15.5999 16.8917 15.642 16.8167 15.7171C16.7417 15.7921 16.6995 15.8938 16.6995 15.9999C16.6995 16.106 16.7417 16.2077 16.8167 16.2827C16.8917 16.3578 16.9934 16.3999 17.0995 16.3999",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2995 15.6001H17.4995V16.4001H18.2995V15.6001Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 15.6001H18.2998V16.4001H19.0998V15.6001Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8999 15.6001H19.0999V16.4001H19.4999C19.606 16.4001 19.7077 16.358 19.7827 16.2829C19.8578 16.2079 19.8999 16.1062 19.8999 16.0001",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0997 16.4001C21.3206 16.4001 21.4997 16.221 21.4997 16.0001C21.4997 15.7792 21.3206 15.6001 21.0997 15.6001C20.8788 15.6001 20.6997 15.7792 20.6997 16.0001C20.6997 16.221 20.8788 16.4001 21.0997 16.4001Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6998 16.4001C22.9207 16.4001 23.0998 16.221 23.0998 16.0001C23.0998 15.7792 22.9207 15.6001 22.6998 15.6001C22.4789 15.6001 22.2998 15.7792 22.2998 16.0001C22.2998 16.221 22.4789 16.4001 22.6998 16.4001Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 15.6001H23.8999V16.4001H24.6999V15.6001Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 15.6001H24.6997V16.4001H25.4997V15.6001Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 15.6001H25.4995V16.4001H26.2995V15.6001Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 15.6001H26.2998V16.4001H27.0998V15.6001Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 15.6001H27.8999V16.4001H28.6999V15.6001Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 16.3999V15.5999H29.4998V15.9999C29.4998 16.106 29.5419 16.2077 29.617 16.2827C29.692 16.3578 29.7937 16.3999 29.8998 16.3999",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 15.6001H30.2998V16.4001H31.0998V15.6001Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 15.6001V16.4001H31.8996V16.0001C31.8996 15.894 31.8575 15.7923 31.7825 15.7173C31.7074 15.6422 31.6057 15.6001 31.4996 15.6001",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6998 16.4001C34.9207 16.4001 35.0998 16.221 35.0998 16.0001C35.0998 15.7792 34.9207 15.6001 34.6998 15.6001C34.4789 15.6001 34.2998 15.7792 34.2998 16.0001C34.2998 16.221 34.4789 16.4001 34.6998 16.4001Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8999 16.3999H36.6999V15.5999H36.2999C36.1938 15.5999 36.0921 15.642 36.0171 15.7171C35.942 15.7921 35.8999 15.8938 35.8999 15.9999",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 15.6001H36.6997V16.4001H37.4997V15.6001Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 15.6001V16.4001H38.2995V16.0001C38.2995 15.894 38.2574 15.7923 38.1824 15.7173C38.1073 15.6422 38.0056 15.6001 37.8995 15.6001",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09971 17.1999C5.32062 17.1999 5.49971 17.0208 5.49971 16.7999C5.49971 16.579 5.32062 16.3999 5.09971 16.3999C4.87879 16.3999 4.69971 16.579 4.69971 16.7999C4.69971 17.0208 4.87879 17.1999 5.09971 17.1999Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09961 17.2002V16.4002H6.29961V16.8002C6.29961 16.9063 6.34175 17.008 6.41677 17.083C6.49178 17.1581 6.59352 17.2002 6.69961 17.2002",
    fill: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09961 16.3999V17.1999H7.49961C7.6057 17.1999 7.70744 17.1578 7.78245 17.0827C7.85747 17.0077 7.89961 16.906 7.89961 16.7999C7.89961 16.6938 7.85747 16.5921 7.78245 16.5171C7.70744 16.442 7.6057 16.3999 7.49961 16.3999",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 16.3999H8.69951V16.7999C8.69951 16.906 8.74165 17.0077 8.81667 17.0827C8.89168 17.1578 8.99343 17.1999 9.09951 17.1999C9.2056 17.1999 9.30734 17.1578 9.38235 17.0827C9.45737 17.0077 9.49951 16.906 9.49951 16.7999",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 16.3999H10.2998V17.1999H11.0998V16.3999Z",
    fill: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 17.2002H13.4997V16.8002C13.4997 16.6941 13.4576 16.5924 13.3826 16.5174C13.3075 16.4423 13.2058 16.4002 13.0997 16.4002C12.9936 16.4002 12.8919 16.4423 12.8169 16.5174C12.7418 16.5924 12.6997 16.6941 12.6997 16.8002",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 16.3999H15.0996V17.1999H15.8996V16.3999Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 16.3999V17.1999H16.2999C16.406 17.1999 16.5077 17.1578 16.5827 17.0827C16.6578 17.0077 16.6999 16.906 16.6999 16.7999C16.6999 16.6938 16.6578 16.5921 16.5827 16.5171C16.5077 16.442 16.406 16.3999 16.2999 16.3999",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6997 17.2002V16.4002H23.8997V16.8002C23.8997 16.9063 23.9418 17.008 24.0169 17.083C24.0919 17.1581 24.1936 17.2002 24.2997 17.2002",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 16.3999H24.6995V17.1999H25.0995C25.2056 17.1999 25.3073 17.1578 25.3824 17.0827C25.4574 17.0077 25.4995 16.906 25.4995 16.7999",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 17.2002V16.4002H26.2996V16.8002C26.2996 16.9063 26.3418 17.008 26.4168 17.083C26.4918 17.1581 26.5935 17.2002 26.6996 17.2002",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 16.3999H27.0996V17.1999H27.8996V16.3999Z",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 16.3999H27.8999V17.1999H28.6999V16.3999Z",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 16.3999V17.1999H29.4997V16.7999C29.4997 16.6938 29.4576 16.5921 29.3826 16.5171C29.3075 16.442 29.2058 16.3999 29.0997 16.3999",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 16.3999H31.0996V17.1999H31.8996V16.3999Z",
    fill: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8999 16.3999V17.1999H32.6999V16.7999C32.6999 16.6938 32.6578 16.5921 32.5827 16.5171C32.5077 16.442 32.406 16.3999 32.2999 16.3999",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8999 17.2002V16.4002H35.4999C35.3938 16.4002 35.2921 16.4423 35.2171 16.5174C35.142 16.5924 35.0999 16.6941 35.0999 16.8002C35.0999 16.9063 35.142 17.008 35.2171 17.083C35.2921 17.1581 35.3938 17.2002 35.4999 17.2002",
    fill: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6999 16.3999H35.8999V17.1999H36.6999V16.3999Z",
    fill: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 16.3999H36.6997V17.1999H37.4997V16.3999Z",
    fill: "white"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2998 16.3999H37.4998V17.1999H37.8998C38.0059 17.1999 38.1076 17.1578 38.1826 17.0827C38.2577 17.0077 38.2998 16.906 38.2998 16.7999",
    fill: "white"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2998 18H3.0998V17.2H2.6998C2.59372 17.2 2.49198 17.2421 2.41696 17.3172C2.34195 17.3922 2.2998 17.4939 2.2998 17.6",
    fill: "white"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 17.2002V18.0002H3.49961C3.6057 18.0002 3.70744 17.9581 3.78245 17.883C3.85747 17.808 3.89961 17.7063 3.89961 17.6002C3.89961 17.4941 3.85747 17.3924 3.78245 17.3174C3.70744 17.2423 3.6057 17.2002 3.49961 17.2002",
    fill: "white"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 18H6.29951V17.6C6.29951 17.4939 6.25737 17.3922 6.18235 17.3172C6.10734 17.2421 6.0056 17.2 5.89951 17.2C5.79343 17.2 5.69168 17.2421 5.61667 17.3172C5.54165 17.3922 5.49951 17.4939 5.49951 17.6",
    fill: "white"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8999 18H8.6999V17.6C8.6999 17.4939 8.65776 17.3922 8.58275 17.3172C8.50773 17.2421 8.40599 17.2 8.2999 17.2C8.19382 17.2 8.09207 17.2421 8.01706 17.3172C7.94204 17.3922 7.8999 17.4939 7.8999 17.6",
    fill: "white"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 17.2002H10.2996V17.6002C10.2996 17.7063 10.3418 17.808 10.4168 17.883C10.4918 17.9581 10.5935 18.0002 10.6996 18.0002C10.8057 18.0002 10.9074 17.9581 10.9825 17.883C11.0575 17.808 11.0996 17.7063 11.0996 17.6002",
    fill: "white"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 18V17.2H12.2997C12.1936 17.2 12.0919 17.2421 12.0169 17.3172C11.9418 17.3922 11.8997 17.4939 11.8997 17.6C11.8997 17.7061 11.9418 17.8078 12.0169 17.8828C12.0919 17.9579 12.1936 18 12.2997 18",
    fill: "white"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 17.2002H12.6997V18.0002H13.4997V17.2002Z",
    fill: "white"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 17.2002H13.4995V18.0002H14.2995V17.2002Z",
    fill: "white"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0998 17.2002H14.2998V18.0002H15.0998V17.2002Z",
    fill: "white"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 17.2002H15.0996V18.0002H15.8996V17.2002Z",
    fill: "white"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8995 18.0002C26.1204 18.0002 26.2995 17.8211 26.2995 17.6002C26.2995 17.3793 26.1204 17.2002 25.8995 17.2002C25.6786 17.2002 25.4995 17.3793 25.4995 17.6002C25.4995 17.8211 25.6786 18.0002 25.8995 18.0002Z",
    fill: "white"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 17.2002H28.6997V18.0002H29.4997V17.2002Z",
    fill: "white"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 17.2002V18.0002H29.8995C30.0056 18.0002 30.1073 17.9581 30.1824 17.883C30.2574 17.808 30.2995 17.7063 30.2995 17.6002C30.2995 17.4941 30.2574 17.3924 30.1824 17.3174C30.1073 17.2423 30.0056 17.2002 29.8995 17.2002",
    fill: "white"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 17.2002H31.0996V18.0002H31.8996V17.2002Z",
    fill: "white"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 17.2002H31.8999V18.0002H32.6999V17.2002Z",
    fill: "white"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6997 17.2002V18.0002H33.4997V17.6002C33.4997 17.4941 33.4576 17.3924 33.3826 17.3174C33.3075 17.2423 33.2058 17.2002 33.0997 17.2002",
    fill: "white"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2998 18H35.0998V17.6C35.0998 17.4939 35.0577 17.3922 34.9826 17.3172C34.9076 17.2421 34.8059 17.2 34.6998 17.2C34.5937 17.2 34.492 17.2421 34.417 17.3172C34.3419 17.3922 34.2998 17.4939 34.2998 17.6",
    fill: "white"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 17.2002H35.8997V17.6002C35.8997 17.7063 35.9418 17.808 36.0169 17.883C36.0919 17.9581 36.1936 18.0002 36.2997 18.0002C36.4058 18.0002 36.5075 17.9581 36.5826 17.883C36.6576 17.808 36.6997 17.7063 36.6997 17.6002",
    fill: "white"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0998 18H2.2998V18.8H3.0998V18Z",
    fill: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 18.7998V17.9998H5.09951C4.99343 17.9998 4.89168 18.0419 4.81667 18.117C4.74165 18.192 4.69951 18.2937 4.69951 18.3998C4.69951 18.5059 4.74165 18.6076 4.81667 18.6826C4.89168 18.7577 4.99343 18.7998 5.09951 18.7998",
    fill: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 18H5.49951V18.8H6.29951V18Z",
    fill: "white"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 18H6.2998V18.8H7.0998V18Z",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 18H7.09961V18.8H7.89961V18Z",
    fill: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6999 18H7.8999V18.8H8.6999V18Z",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 18H8.69971V18.8H9.49971V18Z",
    fill: "white"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 18V18.8H10.2995V18.4C10.2995 18.2939 10.2574 18.1922 10.1824 18.1172C10.1073 18.0421 10.0056 18 9.89951 18",
    fill: "white"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4996 18.8C11.7205 18.8 11.8996 18.6209 11.8996 18.4C11.8996 18.1791 11.7205 18 11.4996 18C11.2787 18 11.0996 18.1791 11.0996 18.4C11.0996 18.6209 11.2787 18.8 11.4996 18.8Z",
    fill: "white"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 18H12.6997V18.8H13.4997V18Z",
    fill: "white"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 18H13.4995V18.8H14.2995V18Z",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 18.7998V17.9998H15.0999V18.3998C15.0999 18.5059 15.142 18.6076 15.2171 18.6826C15.2921 18.7577 15.3938 18.7998 15.4999 18.7998",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 18V18.8H16.6999V18.4C16.6999 18.2939 16.6578 18.1922 16.5827 18.1172C16.5077 18.0421 16.406 18 16.2999 18",
    fill: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2999 18.8C24.5208 18.8 24.6999 18.6209 24.6999 18.4C24.6999 18.1791 24.5208 18 24.2999 18C24.079 18 23.8999 18.1791 23.8999 18.4C23.8999 18.6209 24.079 18.8 24.2999 18.8Z",
    fill: "white"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 18.7998H27.8996V18.3998C27.8996 18.2937 27.8575 18.192 27.7825 18.117C27.7074 18.0419 27.6057 17.9998 27.4996 17.9998C27.3935 17.9998 27.2918 18.0419 27.2168 18.117C27.1418 18.192 27.0996 18.2937 27.0996 18.3998",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 18H28.6997V18.8H29.4997V18Z",
    fill: "white"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 18H31.0996V18.8H31.8996V18Z",
    fill: "white"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 18H31.8999V18.8H32.6999V18Z",
    fill: "white"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 18H32.6997V18.8H33.4997V18Z",
    fill: "white"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 18H33.4995V18.8H34.2995V18Z",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 18H34.2998V18.8H35.0998V18Z",
    fill: "white"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0996 18V18.8H35.4996C35.6057 18.8 35.7074 18.7579 35.7825 18.6828C35.8575 18.6078 35.8996 18.5061 35.8996 18.4C35.8996 18.2939 35.8575 18.1922 35.7825 18.1172C35.7074 18.0421 35.6057 18 35.4996 18",
    fill: "white"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 18.7998H37.4997V18.3998C37.4997 18.2937 37.4576 18.192 37.3826 18.117C37.3075 18.0419 37.2058 17.9998 37.0997 17.9998C36.9936 17.9998 36.8919 18.0419 36.8169 18.117C36.7418 18.192 36.6997 18.2937 36.6997 18.3998",
    fill: "white"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0998 18.7998H2.2998V19.5998H3.0998V18.7998Z",
    fill: "white"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 18.7998H5.49951V19.5998H6.29951V18.7998Z",
    fill: "white"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 18.7998H8.69971V19.5998H9.49971V18.7998Z",
    fill: "white"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 18.7998H9.49951V19.5998H10.2995V18.7998Z",
    fill: "white"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2998 18.7998V19.5998H11.0998V19.1998C11.0998 19.0937 11.0577 18.992 10.9826 18.917C10.9076 18.8419 10.8059 18.7998 10.6998 18.7998",
    fill: "white"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 18.7998H12.6997V19.5998H13.4997V18.7998Z",
    fill: "white"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 18.7998H13.4995V19.5998H14.2995V18.7998Z",
    fill: "white"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6999 18.7998H15.8999V19.5998H16.6999V18.7998Z",
    fill: "white"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6997 19.6001H25.4997V18.8001H25.0997C24.9936 18.8001 24.8919 18.8422 24.8169 18.9173C24.7418 18.9923 24.6997 19.094 24.6997 19.2001",
    fill: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 18.7998V19.5998H26.2995V19.1998C26.2995 19.0937 26.2574 18.992 26.1824 18.917C26.1073 18.8419 26.0056 18.7998 25.8995 18.7998",
    fill: "white"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 18.7998H27.0996V19.5998H27.8996V18.7998Z",
    fill: "white"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 18.7998H27.8999V19.5998H28.6999V18.7998Z",
    fill: "white"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 18.7998H28.6997V19.5998H29.4997V18.7998Z",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 18.7998H31.0996V19.5998H31.8996V18.7998Z",
    fill: "white"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 18.7998H34.2998V19.5998H35.0998V18.7998Z",
    fill: "white"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 18.7998H36.6997V19.5998H37.4997V18.7998Z",
    fill: "white"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0998 19.6001H2.2998V20.4001H3.0998V19.6001Z",
    fill: "white"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 19.6001H5.49951V20.4001H6.29951V19.6001Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49961 20.4001C7.72052 20.4001 7.89961 20.221 7.89961 20.0001C7.89961 19.7792 7.72052 19.6001 7.49961 19.6001C7.2787 19.6001 7.09961 19.7792 7.09961 20.0001C7.09961 20.221 7.2787 20.4001 7.49961 20.4001Z",
    fill: "white"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 19.6001H8.69971V20.4001H9.49971V19.6001Z",
    fill: "white"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 19.6001H9.49951V20.4001H10.2995V19.6001Z",
    fill: "white"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 19.6001H10.2998V20.4001H11.0998V19.6001Z",
    fill: "white"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 19.6001V20.4001H11.8996V20.0001C11.8996 19.894 11.8575 19.7923 11.7825 19.7173C11.7074 19.6422 11.6057 19.6001 11.4996 19.6001",
    fill: "white"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 20.3999V19.5999H12.6995V19.9999C12.6995 20.106 12.7417 20.2077 12.8167 20.2827C12.8917 20.3578 12.9934 20.3999 13.0995 20.3999",
    fill: "white"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 19.6001H13.4995V20.4001H14.2995V19.6001Z",
    fill: "white"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 19.6001V20.4001H15.0998V20.0001C15.0998 19.894 15.0577 19.7923 14.9826 19.7173C14.9076 19.6422 14.8059 19.6001 14.6998 19.6001",
    fill: "white"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 19.6001H15.8997V20.0001C15.8997 20.1062 15.9418 20.2079 16.0169 20.2829C16.0919 20.358 16.1936 20.4001 16.2997 20.4001C16.4058 20.4001 16.5075 20.358 16.5826 20.2829C16.6576 20.2079 16.6997 20.1062 16.6997 20.0001",
    fill: "white"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 19.6001H24.6997V20.4001H25.4997V19.6001Z",
    fill: "white"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 19.6001H25.4995V20.4001H26.2995V19.6001Z",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 19.6001H26.2998V20.4001H27.0998V19.6001Z",
    fill: "white"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 19.6001H27.0996V20.4001H27.8996V19.6001Z",
    fill: "white"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 19.6001H28.6995V20.0001C28.6995 20.1062 28.7417 20.2079 28.8167 20.2829C28.8917 20.358 28.9934 20.4001 29.0995 20.4001C29.2056 20.4001 29.3073 20.358 29.3824 20.2829C29.4574 20.2079 29.4995 20.1062 29.4995 20.0001",
    fill: "white"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 19.6001H31.0996V20.4001H31.8996V19.6001Z",
    fill: "white"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0997 20.4001C33.3206 20.4001 33.4997 20.221 33.4997 20.0001C33.4997 19.7792 33.3206 19.6001 33.0997 19.6001C32.8788 19.6001 32.6997 19.7792 32.6997 20.0001C32.6997 20.221 32.8788 20.4001 33.0997 20.4001Z",
    fill: "white"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 19.6001H34.2998V20.4001H35.0998V19.6001Z",
    fill: "white"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8999 20.3999H36.6999V19.5999H36.2999C36.1938 19.5999 36.0921 19.642 36.0171 19.7171C35.942 19.7921 35.8999 19.8938 35.8999 19.9999",
    fill: "white"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 19.6001H36.6997V20.4001H37.4997V19.6001Z",
    fill: "white"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 19.6001V20.4001H38.2995V20.0001C38.2995 19.894 38.2574 19.7923 38.1824 19.7173C38.1073 19.6422 38.0056 19.6001 37.8995 19.6001",
    fill: "white"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0998 20.3999H2.2998V21.1999H3.0998V20.3999Z",
    fill: "white"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 20.3999H3.09961V21.1999H3.89961V20.3999Z",
    fill: "white"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8999 20.3999V21.1999H4.2999C4.40599 21.1999 4.50773 21.1578 4.58274 21.0827C4.65776 21.0077 4.6999 20.906 4.6999 20.7999C4.6999 20.6938 4.65776 20.5921 4.58274 20.5171C4.50773 20.442 4.40599 20.3999 4.2999 20.3999",
    fill: "white"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 20.3999H5.49951V21.1999H6.29951V20.3999Z",
    fill: "white"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 20.3999H8.69971V21.1999H9.49971V20.3999Z",
    fill: "white"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 20.3999H9.49951V21.1999H10.2995V20.3999Z",
    fill: "white"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 20.3999H10.2998V21.1999H11.0998V20.3999Z",
    fill: "white"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 20.3999H11.0996V21.1999H11.8996V20.3999Z",
    fill: "white"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8999 20.3999V21.1999H12.2999C12.406 21.1999 12.5077 21.1578 12.5827 21.0827C12.6578 21.0077 12.6999 20.906 12.6999 20.7999C12.6999 20.6938 12.6578 20.5921 12.5827 20.5171C12.5077 20.442 12.406 20.3999 12.2999 20.3999",
    fill: "white"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 20.3999H13.4995V21.1999H14.2995V20.3999Z",
    fill: "white"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0998 20.3999H14.2998V21.1999H15.0998V20.3999Z",
    fill: "white"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 20.3999H24.6997V21.1999H25.4997V20.3999Z",
    fill: "white"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 20.3999H25.4995V21.1999H26.2995V20.3999Z",
    fill: "white"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 20.3999H26.2998V21.1999H27.0998V20.3999Z",
    fill: "white"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 20.3999H27.0996V21.1999H27.8996V20.3999Z",
    fill: "white"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 21.2002H30.2995V20.4002H29.8995C29.7934 20.4002 29.6917 20.4423 29.6167 20.5174C29.5417 20.5924 29.4995 20.6941 29.4995 20.8002",
    fill: "white"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 20.3999H30.2998V21.1999H31.0998V20.3999Z",
    fill: "white"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 20.3999H31.0996V21.1999H31.8996V20.3999Z",
    fill: "white"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 20.3999H34.2998V21.1999H35.0998V20.3999Z",
    fill: "white"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 20.3999H35.0996V21.1999H35.8996V20.3999Z",
    fill: "white"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6999 20.3999H35.8999V21.1999H36.6999V20.3999Z",
    fill: "white"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 20.3999H36.6997V21.1999H37.4997V20.3999Z",
    fill: "white"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 20.3999H37.4995V21.1999H38.2995V20.3999Z",
    fill: "white"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0998 21.2002H2.2998V22.0002H3.0998V21.2002Z",
    fill: "white"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8999 21.2002H3.0999V22.0002H3.4999C3.60599 22.0002 3.70773 21.9581 3.78275 21.883C3.85776 21.808 3.8999 21.7063 3.8999 21.6002",
    fill: "white"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69971 22H5.49971V21.2H5.09971C4.99362 21.2 4.89188 21.2421 4.81686 21.3172C4.74185 21.3922 4.69971 21.4939 4.69971 21.6",
    fill: "white"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 21.2002H5.49951V22.0002H6.29951V21.2002Z",
    fill: "white"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 21.2002H6.2998V22.0002H7.0998V21.2002Z",
    fill: "white"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 21.2002H7.09961V22.0002H7.89961V21.2002Z",
    fill: "white"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6999 21.2002H7.8999V22.0002H8.6999V21.2002Z",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 21.2002H8.69951V22.0002H9.09951C9.2056 22.0002 9.30734 21.9581 9.38235 21.883C9.45737 21.808 9.49951 21.7063 9.49951 21.6002",
    fill: "white"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 21.2002H10.2998V22.0002H11.0998V21.2002Z",
    fill: "white"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 21.2002H11.0996V22.0002H11.8996V21.2002Z",
    fill: "white"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 22V21.2H13.0995C12.9934 21.2 12.8917 21.2421 12.8167 21.3172C12.7417 21.3922 12.6995 21.4939 12.6995 21.6C12.6995 21.7061 12.7417 21.8078 12.8167 21.8828C12.8917 21.9579 12.9934 22 13.0995 22",
    fill: "white"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 21.2002H13.4995V22.0002H14.2995V21.2002Z",
    fill: "white"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 21.2002H14.2996V22.0002H14.6996C14.8057 22.0002 14.9074 21.9581 14.9825 21.883C15.0575 21.808 15.0996 21.7063 15.0996 21.6002",
    fill: "white"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 22V21.2H24.6995V21.6C24.6995 21.7061 24.7417 21.8078 24.8167 21.8828C24.8917 21.9579 24.9934 22 25.0995 22",
    fill: "white"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2998 21.2002H25.4998V22.0002H25.8998C26.0059 22.0002 26.1076 21.9581 26.1826 21.883C26.2577 21.808 26.2998 21.7063 26.2998 21.6002",
    fill: "white"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8999 22V21.2H27.0999V21.6C27.0999 21.7061 27.142 21.8078 27.2171 21.8828C27.2921 21.9579 27.3938 22 27.4999 22",
    fill: "white"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8999 21.2002V22.0002H28.6999V21.6002C28.6999 21.4941 28.6578 21.3924 28.5827 21.3174C28.5077 21.2423 28.406 21.2002 28.2999 21.2002",
    fill: "white"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 22V21.2H29.4998V21.6C29.4998 21.7061 29.5419 21.8078 29.617 21.8828C29.692 21.9579 29.7937 22 29.8998 22",
    fill: "white"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 21.2002H30.2998V22.0002H31.0998V21.2002Z",
    fill: "white"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 21.2002H31.0996V22.0002H31.8996V21.2002Z",
    fill: "white"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 21.2002H31.8999V22.0002H32.6999V21.2002Z",
    fill: "white"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 21.2002H32.6997V22.0002H33.4997V21.2002Z",
    fill: "white"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 21.2002H33.4995V22.0002H34.2995V21.2002Z",
    fill: "white"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0996 21.2002H34.2996V22.0002H34.6996C34.8057 22.0002 34.9074 21.9581 34.9825 21.883C35.0575 21.808 35.0996 21.7063 35.0996 21.6002",
    fill: "white"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 21.2002H37.4995V22.0002H38.2995V21.2002Z",
    fill: "white"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0998 22H2.2998V22.8H3.0998V22Z",
    fill: "white"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69971 22.7998V21.9998H4.29971C4.19362 21.9998 4.09188 22.0419 4.01686 22.117C3.94185 22.192 3.89971 22.2937 3.89971 22.3998C3.89971 22.5059 3.94185 22.6076 4.01686 22.6826C4.09188 22.7577 4.19362 22.7998 4.29971 22.7998",
    fill: "white"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49971 22H4.69971V22.8H5.49971V22Z",
    fill: "white"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 22H6.2998V22.8H7.0998V22Z",
    fill: "white"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6999 22H7.8999V22.8H8.6999V22Z",
    fill: "white"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 22.7998H10.2995V21.9998H9.89951C9.79343 21.9998 9.69168 22.0419 9.61667 22.117C9.54165 22.192 9.49951 22.2937 9.49951 22.3998",
    fill: "white"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 22H10.2998V22.8H11.0998V22Z",
    fill: "white"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8999 22H11.0999V22.8H11.4999C11.606 22.8 11.7077 22.7579 11.7827 22.6828C11.8578 22.6078 11.8999 22.5061 11.8999 22.4",
    fill: "white"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 22H13.4995V22.8H14.2995V22Z",
    fill: "white"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 22.7998H15.8996V22.3998C15.8996 22.2937 15.8575 22.192 15.7825 22.117C15.7074 22.0419 15.6057 21.9998 15.4996 21.9998C15.3935 21.9998 15.2918 22.0419 15.2168 22.117C15.1418 22.192 15.0996 22.2937 15.0996 22.3998",
    fill: "white"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2998 22.7998H27.0998V22.3998C27.0998 22.2937 27.0577 22.192 26.9826 22.117C26.9076 22.0419 26.8059 21.9998 26.6998 21.9998C26.5937 21.9998 26.492 22.0419 26.417 22.117C26.3419 22.192 26.2998 22.2937 26.2998 22.3998",
    fill: "white"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 22H27.8997V22.4C27.8997 22.5061 27.9418 22.6078 28.0169 22.6828C28.0919 22.7579 28.1936 22.8 28.2997 22.8C28.4058 22.8 28.5075 22.7579 28.5826 22.6828C28.6576 22.6078 28.6997 22.5061 28.6997 22.4",
    fill: "white"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 22.7998V21.9998H30.2996V22.3998C30.2996 22.5059 30.3418 22.6076 30.4168 22.6826C30.4918 22.7577 30.5935 22.7998 30.6996 22.7998",
    fill: "white"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 22H31.0996V22.8H31.8996V22Z",
    fill: "white"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6997 22H31.8997V22.8H32.2997C32.4058 22.8 32.5075 22.7579 32.5826 22.6828C32.6576 22.6078 32.6997 22.5061 32.6997 22.4",
    fill: "white"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4996 22.8C35.7205 22.8 35.8996 22.6209 35.8996 22.4C35.8996 22.1791 35.7205 22 35.4996 22C35.2787 22 35.0996 22.1791 35.0996 22.4C35.0996 22.6209 35.2787 22.8 35.4996 22.8Z",
    fill: "white"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2998 22H37.4998V22.4C37.4998 22.5061 37.5419 22.6078 37.617 22.6828C37.692 22.7579 37.7937 22.8 37.8998 22.8C38.0059 22.8 38.1076 22.7579 38.1826 22.6828C38.2577 22.6078 38.2998 22.5061 38.2998 22.4",
    fill: "white"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 23.6001V22.8001H2.29961V23.2001C2.29961 23.3062 2.34175 23.4079 2.41677 23.4829C2.49178 23.558 2.59352 23.6001 2.69961 23.6001",
    fill: "white"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 22.7998V23.5998H3.49961C3.6057 23.5998 3.70744 23.5577 3.78245 23.4826C3.85747 23.4076 3.89961 23.3059 3.89961 23.1998C3.89961 23.0937 3.85747 22.992 3.78245 22.917C3.70744 22.8419 3.6057 22.7998 3.49961 22.7998",
    fill: "white"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49971 22.7998H4.69971V23.5998H5.49971V22.7998Z",
    fill: "white"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 22.7998H6.2998V23.5998H7.0998V22.7998Z",
    fill: "white"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 22.7998H7.09961V23.5998H7.89961V22.7998Z",
    fill: "white"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 22.7998H7.89971V23.5998H8.29971C8.40579 23.5998 8.50754 23.5577 8.58255 23.4826C8.65756 23.4076 8.69971 23.3059 8.69971 23.1998",
    fill: "white"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2998 23.6001V22.8001H9.4998V23.2001C9.4998 23.3062 9.54195 23.4079 9.61696 23.4829C9.69198 23.558 9.79372 23.6001 9.8998 23.6001",
    fill: "white"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 22.7998H10.2996V23.5998H10.6996C10.8057 23.5998 10.9074 23.5577 10.9825 23.4826C11.0575 23.4076 11.0996 23.3059 11.0996 23.1998",
    fill: "white"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 23.6001V22.8001H12.2997C12.1936 22.8001 12.0919 22.8422 12.0169 22.9173C11.9418 22.9923 11.8997 23.094 11.8997 23.2001C11.8997 23.3062 11.9418 23.4079 12.0169 23.4829C12.0919 23.558 12.1936 23.6001 12.2997 23.6001",
    fill: "white"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 22.7998H12.6997V23.5998H13.4997V22.7998Z",
    fill: "white"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 22.7998H13.4995V23.5998H14.2995V22.7998Z",
    fill: "white"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 22.7998H15.0996V23.5998H15.8996V22.7998Z",
    fill: "white"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 22.7998V23.5998H16.2999C16.406 23.5998 16.5077 23.5577 16.5827 23.4826C16.6578 23.4076 16.6999 23.3059 16.6999 23.1998C16.6999 23.0937 16.6578 22.992 16.5827 22.917C16.5077 22.8419 16.406 22.7998 16.2999 22.7998",
    fill: "white"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 23.6001H24.6999V22.8001H24.2999C24.1938 22.8001 24.0921 22.8422 24.0171 22.9173C23.942 22.9923 23.8999 23.094 23.8999 23.2001",
    fill: "white"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 22.7998H24.6997V23.5998H25.4997V22.7998Z",
    fill: "white"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 22.7998H25.4995V23.5998H26.2995V22.7998Z",
    fill: "white"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 22.7998H26.2998V23.5998H27.0998V22.7998Z",
    fill: "white"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 22.7998V23.5998H27.4996C27.6057 23.5998 27.7074 23.5577 27.7825 23.4826C27.8575 23.4076 27.8996 23.3059 27.8996 23.1998C27.8996 23.0937 27.8575 22.992 27.7825 22.917C27.7074 22.8419 27.6057 22.7998 27.4996 22.7998",
    fill: "white"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8995 23.5998C30.1204 23.5998 30.2995 23.4207 30.2995 23.1998C30.2995 22.9789 30.1204 22.7998 29.8995 22.7998C29.6786 22.7998 29.4995 22.9789 29.4995 23.1998C29.4995 23.4207 29.6786 23.5998 29.8995 23.5998Z",
    fill: "white"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8995 23.5998C34.1204 23.5998 34.2995 23.4207 34.2995 23.1998C34.2995 22.9789 34.1204 22.7998 33.8995 22.7998C33.6786 22.7998 33.4995 22.9789 33.4995 23.1998C33.4995 23.4207 33.6786 23.5998 33.8995 23.5998Z",
    fill: "white"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 23.6001H37.4997V23.2001C37.4997 23.094 37.4576 22.9923 37.3826 22.9173C37.3075 22.8422 37.2058 22.8001 37.0997 22.8001C36.9936 22.8001 36.8919 22.8422 36.8169 22.9173C36.7418 22.9923 36.6997 23.094 36.6997 23.2001",
    fill: "white"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 23.6001H4.69951V24.0001C4.69951 24.1062 4.74165 24.2079 4.81667 24.2829C4.89168 24.358 4.99343 24.4001 5.09951 24.4001C5.2056 24.4001 5.30734 24.358 5.38235 24.2829C5.45737 24.2079 5.49951 24.1062 5.49951 24.0001",
    fill: "white"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 23.6001H6.2998V24.4001H7.0998V23.6001Z",
    fill: "white"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 24.3999V23.5999H12.6995V23.9999C12.6995 24.106 12.7417 24.2077 12.8167 24.2827C12.8917 24.3578 12.9934 24.3999 13.0995 24.3999",
    fill: "white"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 23.6001H13.4998V24.4001H13.8998C14.0059 24.4001 14.1076 24.358 14.1826 24.2829C14.2577 24.2079 14.2998 24.1062 14.2998 24.0001",
    fill: "white"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 23.6001H15.0996V24.4001H15.8996V23.6001Z",
    fill: "white"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0997 24.4001C17.3206 24.4001 17.4997 24.221 17.4997 24.0001C17.4997 23.7792 17.3206 23.6001 17.0997 23.6001C16.8788 23.6001 16.6997 23.7792 16.6997 24.0001C16.6997 24.221 16.8788 24.4001 17.0997 24.4001Z",
    fill: "white"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6998 24.4001C18.9207 24.4001 19.0998 24.221 19.0998 24.0001C19.0998 23.7792 18.9207 23.6001 18.6998 23.6001C18.4789 23.6001 18.2998 23.7792 18.2998 24.0001C18.2998 24.221 18.4789 24.4001 18.6998 24.4001Z",
    fill: "white"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8999 24.3999H20.6999V23.9999C20.6999 23.8938 20.6578 23.7921 20.5827 23.7171C20.5077 23.642 20.406 23.5999 20.2999 23.5999C20.1938 23.5999 20.0921 23.642 20.0171 23.7171C19.942 23.7921 19.8999 23.8938 19.8999 23.9999",
    fill: "white"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6997 23.6001H23.8997V24.0001C23.8997 24.1062 23.9418 24.2079 24.0169 24.2829C24.0919 24.358 24.1936 24.4001 24.2997 24.4001C24.4058 24.4001 24.5075 24.358 24.5826 24.2829C24.6576 24.2079 24.6997 24.1062 24.6997 24.0001",
    fill: "white"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 23.6001H25.4995V24.4001H26.2995V23.6001Z",
    fill: "white"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 23.6001H26.2996V24.4001H26.6996C26.8057 24.4001 26.9074 24.358 26.9825 24.2829C27.0575 24.2079 27.0996 24.1062 27.0996 24.0001",
    fill: "white"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 24.3999V23.5999H28.2997C28.1936 23.5999 28.0919 23.642 28.0169 23.7171C27.9418 23.7921 27.8997 23.8938 27.8997 23.9999C27.8997 24.106 27.9418 24.2077 28.0169 24.2827C28.0919 24.3578 28.1936 24.3999 28.2997 24.3999",
    fill: "white"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 23.6001V24.4001H29.4997V24.0001C29.4997 23.894 29.4576 23.7923 29.3826 23.7173C29.3075 23.6422 29.2058 23.6001 29.0997 23.6001",
    fill: "white"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4996 24.4001C31.7205 24.4001 31.8996 24.221 31.8996 24.0001C31.8996 23.7792 31.7205 23.6001 31.4996 23.6001C31.2787 23.6001 31.0996 23.7792 31.0996 24.0001C31.0996 24.221 31.2787 24.4001 31.4996 24.4001Z",
    fill: "white"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2998 24.3999H35.0998V23.5999H34.6998C34.5937 23.5999 34.492 23.642 34.417 23.7171C34.3419 23.7921 34.2998 23.8938 34.2998 23.9999",
    fill: "white"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0996 23.6001V24.4001H35.8996V24.0001C35.8996 23.894 35.8575 23.7923 35.7825 23.7173C35.7074 23.6422 35.6057 23.6001 35.4996 23.6001",
    fill: "white"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 24.3999V23.5999H36.6995V23.9999C36.6995 24.106 36.7417 24.2077 36.8167 24.2827C36.8917 24.3578 36.9934 24.3999 37.0995 24.3999",
    fill: "white"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 23.6001V24.4001H38.2995V24.0001C38.2995 23.894 38.2574 23.7923 38.1824 23.7173C38.1073 23.6422 38.0056 23.6001 37.8995 23.6001",
    fill: "white"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 25.2002H3.89961V24.4002H3.49961C3.39352 24.4002 3.29178 24.4423 3.21677 24.5174C3.14175 24.5924 3.09961 24.6941 3.09961 24.8002",
    fill: "white"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8999 24.3999V25.1999H4.6999V24.7999C4.6999 24.6938 4.65776 24.5921 4.58274 24.5171C4.50773 24.442 4.40599 24.3999 4.2999 24.3999",
    fill: "white"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 24.3999H6.2998V25.1999H7.0998V24.3999Z",
    fill: "white"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 24.3999H7.09961V25.1999H7.89961V24.3999Z",
    fill: "white"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6999 24.3999H7.8999V25.1999H8.6999V24.3999Z",
    fill: "white"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 24.3999H8.69971V25.1999H9.49971V24.3999Z",
    fill: "white"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 24.3999V25.1999H10.2995V24.7999C10.2995 24.6938 10.2574 24.5921 10.1824 24.5171C10.1073 24.442 10.0056 24.3999 9.89951 24.3999",
    fill: "white"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 25.2002H11.8996V24.8002C11.8996 24.6941 11.8575 24.5924 11.7825 24.5174C11.7074 24.4423 11.6057 24.4002 11.4996 24.4002C11.3935 24.4002 11.2918 24.4423 11.2168 24.5174C11.1418 24.5924 11.0996 24.6941 11.0996 24.8002",
    fill: "white"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 24.3999H15.0996V25.1999H15.8996V24.3999Z",
    fill: "white"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 24.3999V25.1999H16.2999C16.406 25.1999 16.5077 25.1578 16.5827 25.0827C16.6578 25.0077 16.6999 24.906 16.6999 24.7999C16.6999 24.6938 16.6578 24.5921 16.5827 24.5171C16.5077 24.442 16.406 24.3999 16.2999 24.3999",
    fill: "white"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 24.3999H19.8999V25.1999H20.6999V24.3999Z",
    fill: "white"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4995 25.2002H22.2995V24.8002C22.2995 24.6941 22.2574 24.5924 22.1824 24.5174C22.1073 24.4423 22.0056 24.4002 21.8995 24.4002C21.7934 24.4002 21.6917 24.4423 21.6167 24.5174C21.5417 24.5924 21.4995 24.6941 21.4995 24.8002",
    fill: "white"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 25.2002H23.8996V24.8002C23.8996 24.6941 23.8575 24.5924 23.7825 24.5174C23.7074 24.4423 23.6057 24.4002 23.4996 24.4002C23.3935 24.4002 23.2918 24.4423 23.2168 24.5174C23.1418 24.5924 23.0996 24.6941 23.0996 24.8002",
    fill: "white"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2998 24.3999H25.4998V24.7999C25.4998 24.906 25.5419 25.0077 25.617 25.0827C25.692 25.1578 25.7937 25.1999 25.8998 25.1999C26.0059 25.1999 26.1076 25.1578 26.1826 25.0827C26.2577 25.0077 26.2998 24.906 26.2998 24.7999",
    fill: "white"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4996 25.1999C27.7205 25.1999 27.8996 25.0208 27.8996 24.7999C27.8996 24.579 27.7205 24.3999 27.4996 24.3999C27.2787 24.3999 27.0996 24.579 27.0996 24.7999C27.0996 25.0208 27.2787 25.1999 27.4996 25.1999Z",
    fill: "white"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 24.3999H28.6997V25.1999H29.4997V24.3999Z",
    fill: "white"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 24.3999H29.4995V25.1999H30.2995V24.3999Z",
    fill: "white"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 24.3999V25.1999H31.0998V24.7999C31.0998 24.6938 31.0577 24.5921 30.9826 24.5171C30.9076 24.442 30.8059 24.3999 30.6998 24.3999",
    fill: "white"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4995 25.2002V24.4002H33.0995C32.9934 24.4002 32.8917 24.4423 32.8167 24.5174C32.7417 24.5924 32.6995 24.6941 32.6995 24.8002C32.6995 24.9063 32.7417 25.008 32.8167 25.083C32.8917 25.1581 32.9934 25.2002 33.0995 25.2002",
    fill: "white"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 24.3999H33.4995V25.1999H34.2995V24.3999Z",
    fill: "white"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 24.3999H34.2998V25.1999H35.0998V24.3999Z",
    fill: "white"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 24.3999H35.0996V25.1999H35.8996V24.3999Z",
    fill: "white"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8999 24.3999V25.1999H36.6999V24.7999C36.6999 24.6938 36.6578 24.5921 36.5827 24.5171C36.5077 24.442 36.406 24.3999 36.2999 24.3999",
    fill: "white"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 24.3999H37.4995V25.1999H38.2995V24.3999Z",
    fill: "white"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2998 26H3.0998V25.2H2.6998C2.59372 25.2 2.49198 25.2421 2.41696 25.3172C2.34195 25.3922 2.2998 25.4939 2.2998 25.6",
    fill: "white"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 25.2002H3.09961V26.0002H3.89961V25.2002Z",
    fill: "white"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6999 25.2002H3.8999V26.0002H4.6999V25.2002Z",
    fill: "white"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69971 25.2002V26.0002H5.49971V25.6002C5.49971 25.4941 5.45756 25.3924 5.38255 25.3174C5.30753 25.2423 5.20579 25.2002 5.09971 25.2002",
    fill: "white"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 25.2002H6.2998V26.0002H7.0998V25.2002Z",
    fill: "white"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6999 25.2002H7.8999V26.0002H8.6999V25.2002Z",
    fill: "white"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 25.2002H9.49951V26.0002H10.2995V25.2002Z",
    fill: "white"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 25.2002H11.0996V26.0002H11.8996V25.2002Z",
    fill: "white"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 26H13.4997V25.6C13.4997 25.4939 13.4576 25.3922 13.3826 25.3172C13.3075 25.2421 13.2058 25.2 13.0997 25.2C12.9936 25.2 12.8919 25.2421 12.8169 25.3172C12.7418 25.3922 12.6997 25.4939 12.6997 25.6",
    fill: "white"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 26H15.0998V25.2H14.6998C14.5937 25.2 14.492 25.2421 14.417 25.3172C14.3419 25.3922 14.2998 25.4939 14.2998 25.6",
    fill: "white"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 25.2002H15.0999V26.0002H15.4999C15.606 26.0002 15.7077 25.9581 15.7827 25.883C15.8578 25.808 15.8999 25.7063 15.8999 25.6002",
    fill: "white"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 26H17.4997V25.6C17.4997 25.4939 17.4576 25.3922 17.3826 25.3172C17.3075 25.2421 17.2058 25.2 17.0997 25.2C16.9936 25.2 16.8919 25.2421 16.8169 25.3172C16.7418 25.3922 16.6997 25.4939 16.6997 25.6",
    fill: "white"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 25.2002H19.8999V26.0002H20.6999V25.2002Z",
    fill: "white"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2998 26V25.2H21.4998V25.6C21.4998 25.7061 21.5419 25.8078 21.617 25.8828C21.692 25.9579 21.7937 26 21.8998 26",
    fill: "white"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0998 25.2002H22.2998V26.0002H23.0998V25.2002Z",
    fill: "white"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8996 25.2002H23.0996V26.0002H23.8996V25.2002Z",
    fill: "white"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 25.2002V26.0002H24.6999V25.6002C24.6999 25.4941 24.6578 25.3924 24.5827 25.3174C24.5077 25.2423 24.406 25.2002 24.2999 25.2002",
    fill: "white"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6998 26.0002C26.9207 26.0002 27.0998 25.8211 27.0998 25.6002C27.0998 25.3793 26.9207 25.2002 26.6998 25.2002C26.4789 25.2002 26.2998 25.3793 26.2998 25.6002C26.2998 25.8211 26.4789 26.0002 26.6998 26.0002Z",
    fill: "white"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 26V25.2H28.2997C28.1936 25.2 28.0919 25.2421 28.0169 25.3172C27.9418 25.3922 27.8997 25.4939 27.8997 25.6C27.8997 25.7061 27.9418 25.8078 28.0169 25.8828C28.0919 25.9579 28.1936 26 28.2997 26",
    fill: "white"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 25.2002H28.6997V26.0002H29.4997V25.2002Z",
    fill: "white"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 25.2002H29.4995V26.0002H30.2995V25.2002Z",
    fill: "white"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 25.2002H30.2998V26.0002H31.0998V25.2002Z",
    fill: "white"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 25.2002H31.0996V26.0002H31.8996V25.2002Z",
    fill: "white"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8999 25.2002V26.0002H32.6999V25.6002C32.6999 25.4941 32.6578 25.3924 32.5827 25.3174C32.5077 25.2423 32.406 25.2002 32.2999 25.2002",
    fill: "white"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 25.2002H34.2998V26.0002H35.0998V25.2002Z",
    fill: "white"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 25.2002H35.0996V26.0002H35.8996V25.2002Z",
    fill: "white"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6999 25.2002H35.8999V26.0002H36.6999V25.2002Z",
    fill: "white"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 25.2002H36.6997V26.0002H37.4997V25.2002Z",
    fill: "white"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 25.2002H37.4995V26.0002H38.2995V25.2002Z",
    fill: "white"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0998 26H2.2998V26.8H3.0998V26Z",
    fill: "white"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 26H3.09961V26.8H3.89961V26Z",
    fill: "white"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 26H4.69951V26.4C4.69951 26.5061 4.74165 26.6078 4.81667 26.6828C4.89168 26.7579 4.99343 26.8 5.09951 26.8C5.2056 26.8 5.30734 26.7579 5.38235 26.6828C5.45737 26.6078 5.49951 26.5061 5.49951 26.4",
    fill: "white"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 26H6.2998V26.8H7.0998V26Z",
    fill: "white"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 26H7.09961V26.8H7.89961V26Z",
    fill: "white"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6999 26H7.8999V26.8H8.6999V26Z",
    fill: "white"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2998 26.7998V25.9998H9.4998V26.3998C9.4998 26.5059 9.54195 26.6076 9.61696 26.6826C9.69198 26.7577 9.79372 26.7998 9.8998 26.7998",
    fill: "white"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 26H10.2998V26.8H11.0998V26Z",
    fill: "white"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 26H11.0996V26.8H11.8996V26Z",
    fill: "white"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6999 26H11.8999V26.8H12.6999V26Z",
    fill: "white"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 26H12.6997V26.8H13.4997V26Z",
    fill: "white"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0998 26H14.2998V26.8H15.0998V26Z",
    fill: "white"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 26H16.6995V26.4C16.6995 26.5061 16.7417 26.6078 16.8167 26.6828C16.8917 26.7579 16.9934 26.8 17.0995 26.8C17.2056 26.8 17.3073 26.7579 17.3824 26.6828C17.4574 26.6078 17.4995 26.5061 17.4995 26.4",
    fill: "white"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6998 26.8C18.9207 26.8 19.0998 26.6209 19.0998 26.4C19.0998 26.1791 18.9207 26 18.6998 26C18.4789 26 18.2998 26.1791 18.2998 26.4C18.2998 26.6209 18.4789 26.8 18.6998 26.8Z",
    fill: "white"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6997 26H19.8997V26.4C19.8997 26.5061 19.9418 26.6078 20.0169 26.6828C20.0919 26.7579 20.1936 26.8 20.2997 26.8C20.4058 26.8 20.5075 26.7579 20.5826 26.6828C20.6576 26.6078 20.6997 26.5061 20.6997 26.4",
    fill: "white"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0998 26H22.2998V26.8H23.0998V26Z",
    fill: "white"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 26H23.8999V26.8H24.6999V26Z",
    fill: "white"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 26H24.6997V26.8H25.4997V26Z",
    fill: "white"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 26V26.8H26.2995V26.4C26.2995 26.2939 26.2574 26.1922 26.1824 26.1172C26.1073 26.0421 26.0056 26 25.8995 26",
    fill: "white"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 26H29.4995V26.8H30.2995V26Z",
    fill: "white"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 26H30.2998V26.8H31.0998V26Z",
    fill: "white"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 26H31.0996V26.8H31.8996V26Z",
    fill: "white"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 26H31.8999V26.8H32.6999V26Z",
    fill: "white"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6997 26V26.8H33.4997V26.4C33.4997 26.2939 33.4576 26.1922 33.3826 26.1172C33.3075 26.0421 33.2058 26 33.0997 26",
    fill: "white"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 26H34.2998V26.8H35.0998V26Z",
    fill: "white"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6999 26H35.8999V26.8H36.6999V26Z",
    fill: "white"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2998 26H37.4998V26.4C37.4998 26.5061 37.5419 26.6078 37.617 26.6828C37.692 26.7579 37.7937 26.8 37.8998 26.8C38.0059 26.8 38.1076 26.7579 38.1826 26.6828C38.2577 26.6078 38.2998 26.5061 38.2998 26.4",
    fill: "white"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0998 26.7998H2.2998V27.5998H3.0998V26.7998Z",
    fill: "white"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 26.7998H3.09961V27.5998H3.89961V26.7998Z",
    fill: "white"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2998 27.6001V26.8001H5.8998C5.79372 26.8001 5.69198 26.8422 5.61696 26.9173C5.54195 26.9923 5.4998 27.094 5.4998 27.2001C5.4998 27.3062 5.54195 27.4079 5.61696 27.4829C5.69198 27.558 5.79372 27.6001 5.8998 27.6001",
    fill: "white"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 26.7998H6.2998V27.5998H7.0998V26.7998Z",
    fill: "white"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 27.6001V26.8001H7.89971V27.2001C7.89971 27.3062 7.94185 27.4079 8.01686 27.4829C8.09188 27.558 8.19362 27.6001 8.29971 27.6001",
    fill: "white"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 26.7998V27.5998H9.49971V27.1998C9.49971 27.0937 9.45756 26.992 9.38255 26.917C9.30754 26.8419 9.20579 26.7998 9.09971 26.7998",
    fill: "white"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6999 26.7998H11.8999V27.5998H12.6999V26.7998Z",
    fill: "white"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 26.7998H12.6997V27.5998H13.4997V26.7998Z",
    fill: "white"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0998 26.7998H14.2998V27.5998H15.0998V26.7998Z",
    fill: "white"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0996 27.6001H19.8996V27.2001C19.8996 27.094 19.8575 26.9923 19.7825 26.9173C19.7074 26.8422 19.6057 26.8001 19.4996 26.8001C19.3935 26.8001 19.2918 26.8422 19.2168 26.9173C19.1418 26.9923 19.0996 27.094 19.0996 27.2001",
    fill: "white"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0997 27.5998C21.3206 27.5998 21.4997 27.4207 21.4997 27.1998C21.4997 26.9789 21.3206 26.7998 21.0997 26.7998C20.8788 26.7998 20.6997 26.9789 20.6997 27.1998C20.6997 27.4207 20.8788 27.5998 21.0997 27.5998Z",
    fill: "white"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 27.6001V26.8001H22.2996V27.2001C22.2996 27.3062 22.3418 27.4079 22.4168 27.4829C22.4918 27.558 22.5935 27.6001 22.6996 27.6001",
    fill: "white"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8996 26.7998H23.0996V27.5998H23.8996V26.7998Z",
    fill: "white"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 26.7998H23.8999V27.5998H24.6999V26.7998Z",
    fill: "white"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 26.7998H24.6997V27.5998H25.4997V26.7998Z",
    fill: "white"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 26.7998H25.4995V27.5998H26.2995V26.7998Z",
    fill: "white"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2998 26.7998V27.5998H27.0998V27.1998C27.0998 27.0937 27.0577 26.992 26.9826 26.917C26.9076 26.8419 26.8059 26.7998 26.6998 26.7998",
    fill: "white"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2999 27.5998C28.5208 27.5998 28.6999 27.4207 28.6999 27.1998C28.6999 26.9789 28.5208 26.7998 28.2999 26.7998C28.079 26.7998 27.8999 26.9789 27.8999 27.1998C27.8999 27.4207 28.079 27.5998 28.2999 27.5998Z",
    fill: "white"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 26.7998H29.4998V27.1998C29.4998 27.3059 29.5419 27.4076 29.617 27.4826C29.692 27.5577 29.7937 27.5998 29.8998 27.5998C30.0059 27.5998 30.1076 27.5577 30.1826 27.4826C30.2577 27.4076 30.2998 27.3059 30.2998 27.1998",
    fill: "white"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 26.7998H32.6997V27.5998H33.4997V26.7998Z",
    fill: "white"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 26.7998H34.2998V27.5998H35.0998V26.7998Z",
    fill: "white"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6999 26.7998H35.8999V27.5998H36.6999V26.7998Z",
    fill: "white"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 26.7998V27.5998H37.4997V27.1998C37.4997 27.0937 37.4576 26.992 37.3825 26.917C37.3075 26.8419 37.2058 26.7998 37.0997 26.7998",
    fill: "white"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 28.3999V27.5999H2.29961V27.9999C2.29961 28.106 2.34175 28.2077 2.41677 28.2827C2.49178 28.3578 2.59352 28.3999 2.69961 28.3999",
    fill: "white"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 27.6001H3.09961V28.4001H3.89961V27.6001Z",
    fill: "white"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09971 28.4001C5.32062 28.4001 5.49971 28.221 5.49971 28.0001C5.49971 27.7792 5.32062 27.6001 5.09971 27.6001C4.87879 27.6001 4.69971 27.7792 4.69971 28.0001C4.69971 28.221 4.87879 28.4001 5.09971 28.4001Z",
    fill: "white"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 27.6001H6.2998V28.4001H7.0998V27.6001Z",
    fill: "white"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09961 27.6001V28.4001H7.49961C7.6057 28.4001 7.70744 28.358 7.78245 28.2829C7.85747 28.2079 7.89961 28.1062 7.89961 28.0001C7.89961 27.894 7.85747 27.7923 7.78245 27.7173C7.70744 27.6422 7.6057 27.6001 7.49961 27.6001",
    fill: "white"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 27.6001H8.69971V28.4001H9.49971V27.6001Z",
    fill: "white"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2998 28.3999H11.0998V27.9999C11.0998 27.8938 11.0577 27.7921 10.9826 27.7171C10.9076 27.642 10.8059 27.5999 10.6998 27.5999C10.5937 27.5999 10.492 27.642 10.417 27.7171C10.3419 27.7921 10.2998 27.8938 10.2998 27.9999",
    fill: "white"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 28.3999V27.5999H11.8997V27.9999C11.8997 28.106 11.9418 28.2077 12.0169 28.2827C12.0919 28.3578 12.1936 28.3999 12.2997 28.3999",
    fill: "white"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 27.6001H12.6997V28.4001H13.4997V27.6001Z",
    fill: "white"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 28.3999V27.5999H14.2996V27.9999C14.2996 28.106 14.3418 28.2077 14.4168 28.2827C14.4918 28.3578 14.5935 28.3999 14.6996 28.3999",
    fill: "white"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 27.6001H15.0996V28.4001H15.8996V27.6001Z",
    fill: "white"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 27.6001V28.4001H16.2999C16.406 28.4001 16.5077 28.358 16.5827 28.2829C16.6578 28.2079 16.6999 28.1062 16.6999 28.0001C16.6999 27.894 16.6578 27.7923 16.5827 27.7173C16.5077 27.6422 16.406 27.6001 16.2999 27.6001",
    fill: "white"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2998 28.3999H19.0998V27.5999H18.6998C18.5937 27.5999 18.492 27.642 18.417 27.7171C18.3419 27.7921 18.2998 27.8938 18.2998 27.9999",
    fill: "white"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8999 27.6001H19.0999V28.4001H19.4999C19.606 28.4001 19.7077 28.358 19.7827 28.2829C19.8578 28.2079 19.8999 28.1062 19.8999 28.0001",
    fill: "white"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 27.6001H23.8999V28.4001H24.6999V27.6001Z",
    fill: "white"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 27.6001H24.6997V28.4001H25.4997V27.6001Z",
    fill: "white"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 27.6001H25.4995V28.4001H26.2995V27.6001Z",
    fill: "white"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 27.6001H26.2998V28.4001H27.0998V27.6001Z",
    fill: "white"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0997 28.4001C29.3206 28.4001 29.4997 28.221 29.4997 28.0001C29.4997 27.7792 29.3206 27.6001 29.0997 27.6001C28.8788 27.6001 28.6997 27.7792 28.6997 28.0001C28.6997 28.221 28.8788 28.4001 29.0997 28.4001Z",
    fill: "white"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 28.3999H31.0998V27.5999H30.6998C30.5937 27.5999 30.492 27.642 30.417 27.7171C30.3419 27.7921 30.2998 27.8938 30.2998 27.9999",
    fill: "white"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 27.6001V28.4001H31.4996C31.6057 28.4001 31.7074 28.358 31.7825 28.2829C31.8575 28.2079 31.8996 28.1062 31.8996 28.0001C31.8996 27.894 31.8575 27.7923 31.7825 27.7173C31.7074 27.6422 31.6057 27.6001 31.4996 27.6001",
    fill: "white"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4995 28.3999V27.5999H32.6995V27.9999C32.6995 28.106 32.7417 28.2077 32.8167 28.2827C32.8917 28.3578 32.9934 28.3999 33.0995 28.3999",
    fill: "white"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 27.6001H33.4995V28.4001H34.2995V27.6001Z",
    fill: "white"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 27.6001H34.2998V28.4001H35.0998V27.6001Z",
    fill: "white"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 27.6001H35.0996V28.4001H35.8996V27.6001Z",
    fill: "white"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6999 27.6001H35.8999V28.4001H36.6999V27.6001Z",
    fill: "white"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 27.6001H36.6995V28.4001H37.0995C37.2056 28.4001 37.3073 28.358 37.3824 28.2829C37.4574 28.2079 37.4995 28.1062 37.4995 28.0001",
    fill: "white"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8999 28.3999H3.0999V28.7999C3.0999 28.906 3.14204 29.0077 3.21706 29.0827C3.29207 29.1578 3.39382 29.1999 3.4999 29.1999C3.60599 29.1999 3.70773 29.1578 3.78275 29.0827C3.85776 29.0077 3.8999 28.906 3.8999 28.7999",
    fill: "white"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 29.2002H6.29951V28.4002H5.89951C5.79343 28.4002 5.69168 28.4423 5.61667 28.5174C5.54165 28.5924 5.49951 28.6941 5.49951 28.8002",
    fill: "white"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09961 28.3999H6.29961V29.1999H6.69961C6.8057 29.1999 6.90744 29.1578 6.98245 29.0827C7.05747 29.0077 7.09961 28.906 7.09961 28.7999",
    fill: "white"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 29.2002V28.4002H8.29971C8.19362 28.4002 8.09188 28.4423 8.01686 28.5174C7.94185 28.5924 7.89971 28.6941 7.89971 28.8002C7.89971 28.9063 7.94185 29.008 8.01686 29.083C8.09188 29.1581 8.19362 29.2002 8.29971 29.2002",
    fill: "white"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 28.3999H8.69951V29.1999H9.09951C9.2056 29.1999 9.30734 29.1578 9.38235 29.0827C9.45737 29.0077 9.49951 28.906 9.49951 28.7999",
    fill: "white"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 28.3999H10.2998V29.1999H11.0998V28.3999Z",
    fill: "white"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 28.3999V29.1999H11.4996C11.6057 29.1999 11.7074 29.1578 11.7825 29.0827C11.8575 29.0077 11.8996 28.906 11.8996 28.7999C11.8996 28.6938 11.8575 28.5921 11.7825 28.5171C11.7074 28.442 11.6057 28.3999 11.4996 28.3999",
    fill: "white"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 29.2002V28.4002H12.6995V28.8002C12.6995 28.9063 12.7417 29.008 12.8167 29.083C12.8917 29.1581 12.9934 29.2002 13.0995 29.2002",
    fill: "white"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 28.3999V29.1999H13.8995C14.0056 29.1999 14.1073 29.1578 14.1824 29.0827C14.2574 29.0077 14.2995 28.906 14.2995 28.7999C14.2995 28.6938 14.2574 28.5921 14.1824 28.5171C14.1073 28.442 14.0056 28.3999 13.8995 28.3999",
    fill: "white"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0996 28.3999H18.2996V28.7999C18.2996 28.906 18.3418 29.0077 18.4168 29.0827C18.4918 29.1578 18.5935 29.1999 18.6996 29.1999C18.8057 29.1999 18.9074 29.1578 18.9825 29.0827C19.0575 29.0077 19.0996 28.906 19.0996 28.7999",
    fill: "white"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6997 29.2002H21.4997V28.8002C21.4997 28.6941 21.4576 28.5924 21.3826 28.5174C21.3075 28.4423 21.2058 28.4002 21.0997 28.4002C20.9936 28.4002 20.8919 28.4423 20.8169 28.5174C20.7418 28.5924 20.6997 28.6941 20.6997 28.8002",
    fill: "white"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 29.2002V28.4002H23.4999C23.3938 28.4002 23.2921 28.4423 23.2171 28.5174C23.142 28.5924 23.0999 28.6941 23.0999 28.8002C23.0999 28.9063 23.142 29.008 23.2171 29.083C23.2921 29.1581 23.3938 29.2002 23.4999 29.2002",
    fill: "white"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 28.3999H23.8999V29.1999H24.6999V28.3999Z",
    fill: "white"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 28.3999H26.2998V29.1999H27.0998V28.3999Z",
    fill: "white"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 28.3999H27.0996V29.1999H27.8996V28.3999Z",
    fill: "white"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8999 28.3999V29.1999H28.6999V28.7999C28.6999 28.6938 28.6578 28.5921 28.5827 28.5171C28.5077 28.442 28.406 28.3999 28.2999 28.3999",
    fill: "white"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 29.2002H30.2995V28.4002H29.8995C29.7934 28.4002 29.6917 28.4423 29.6167 28.5174C29.5417 28.5924 29.4995 28.6941 29.4995 28.8002",
    fill: "white"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 28.3999H30.2996V29.1999H30.6996C30.8057 29.1999 30.9074 29.1578 30.9825 29.0827C31.0575 29.0077 31.0996 28.906 31.0996 28.7999",
    fill: "white"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 28.3999H33.4995V29.1999H34.2995V28.3999Z",
    fill: "white"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 28.3999H35.8997V28.7999C35.8997 28.906 35.9418 29.0077 36.0169 29.0827C36.0919 29.1578 36.1936 29.1999 36.2997 29.1999C36.4058 29.1999 36.5075 29.1578 36.5826 29.0827C36.6576 29.0077 36.6997 28.906 36.6997 28.7999",
    fill: "white"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 29.2002H5.49951V30.0002H6.29951V29.2002Z",
    fill: "white"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49961 30.0002C7.72052 30.0002 7.89961 29.8211 7.89961 29.6002C7.89961 29.3793 7.72052 29.2002 7.49961 29.2002C7.2787 29.2002 7.09961 29.3793 7.09961 29.6002C7.09961 29.8211 7.2787 30.0002 7.49961 30.0002Z",
    fill: "white"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 30H10.2995V29.2H9.89951C9.79343 29.2 9.69168 29.2421 9.61667 29.3172C9.54165 29.3922 9.49951 29.4939 9.49951 29.6",
    fill: "white"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 29.2002H10.2998V30.0002H11.0998V29.2002Z",
    fill: "white"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8999 30H12.6999V29.6C12.6999 29.4939 12.6578 29.3922 12.5827 29.3172C12.5077 29.2421 12.406 29.2 12.2999 29.2C12.1938 29.2 12.0921 29.2421 12.0171 29.3172C11.942 29.3922 11.8999 29.4939 11.8999 29.6",
    fill: "white"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 30H15.0998V29.2H14.6998C14.5937 29.2 14.492 29.2421 14.417 29.3172C14.3419 29.3922 14.2998 29.4939 14.2998 29.6",
    fill: "white"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 29.2002H15.0996V30.0002H15.8996V29.2002Z",
    fill: "white"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 29.2002V30.0002H16.6999V29.6002C16.6999 29.4941 16.6578 29.3924 16.5827 29.3174C16.5077 29.2423 16.406 29.2002 16.2999 29.2002",
    fill: "white"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4996 30.0002C19.7205 30.0002 19.8996 29.8211 19.8996 29.6002C19.8996 29.3793 19.7205 29.2002 19.4996 29.2002C19.2787 29.2002 19.0996 29.3793 19.0996 29.6002C19.0996 29.8211 19.2787 30.0002 19.4996 30.0002Z",
    fill: "white"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4995 30V29.2H20.6995V29.6C20.6995 29.7061 20.7417 29.8078 20.8167 29.8828C20.8917 29.9579 20.9934 30 21.0995 30",
    fill: "white"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4995 29.2002V30.0002H21.8995C22.0056 30.0002 22.1073 29.9581 22.1824 29.883C22.2574 29.808 22.2995 29.7063 22.2995 29.6002C22.2995 29.4941 22.2574 29.3924 22.1824 29.3174C22.1073 29.2423 22.0056 29.2002 21.8995 29.2002",
    fill: "white"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 29.2002H23.8999V30.0002H24.6999V29.2002Z",
    fill: "white"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 29.2002H24.6997V30.0002H25.4997V29.2002Z",
    fill: "white"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 29.2002H25.4995V30.0002H26.2995V29.2002Z",
    fill: "white"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 29.2002H26.2998V30.0002H27.0998V29.2002Z",
    fill: "white"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 29.2002H27.0996V30.0002H27.8996V29.2002Z",
    fill: "white"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 29.2002H27.8999V30.0002H28.6999V29.2002Z",
    fill: "white"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 29.2002H29.4995V30.0002H30.2995V29.2002Z",
    fill: "white"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 30H31.8996V29.2H31.4996C31.3935 29.2 31.2918 29.2421 31.2168 29.3172C31.1418 29.3922 31.0996 29.4939 31.0996 29.6",
    fill: "white"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8999 29.2002V30.0002H32.2999C32.406 30.0002 32.5077 29.9581 32.5827 29.883C32.6578 29.808 32.6999 29.7063 32.6999 29.6002C32.6999 29.4941 32.6578 29.3924 32.5827 29.3174C32.5077 29.2423 32.406 29.2002 32.2999 29.2002",
    fill: "white"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 29.2002H33.4995V30.0002H34.2995V29.2002Z",
    fill: "white"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 29.2002H34.2998V30.0002H35.0998V29.2002Z",
    fill: "white"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0996 29.2002V30.0002H35.4996C35.6057 30.0002 35.7074 29.9581 35.7825 29.883C35.8575 29.808 35.8996 29.7063 35.8996 29.6002C35.8996 29.4941 35.8575 29.3924 35.7825 29.3174C35.7074 29.2423 35.6057 29.2002 35.4996 29.2002",
    fill: "white"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8995 30.0002C38.1204 30.0002 38.2995 29.8211 38.2995 29.6002C38.2995 29.3793 38.1204 29.2002 37.8995 29.2002C37.6786 29.2002 37.4995 29.3793 37.4995 29.6002C37.4995 29.8211 37.6786 30.0002 37.8995 30.0002Z",
    fill: "white"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8999 30.7998V29.9998H3.4999C3.39382 29.9998 3.29207 30.0419 3.21706 30.117C3.14204 30.192 3.0999 30.2937 3.0999 30.3998C3.0999 30.5059 3.14204 30.6076 3.21706 30.6826C3.29207 30.7577 3.39382 30.7998 3.4999 30.7998",
    fill: "white"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6999 30H3.8999V30.8H4.6999V30Z",
    fill: "white"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49971 30H4.69971V30.8H5.49971V30Z",
    fill: "white"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 30H5.49951V30.8H6.29951V30Z",
    fill: "white"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 30H9.49951V30.8H10.2995V30Z",
    fill: "white"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 30H10.2996V30.8H10.6996C10.8057 30.8 10.9074 30.7579 10.9825 30.6828C11.0575 30.6078 11.0996 30.5061 11.0996 30.4",
    fill: "white"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6999 30H11.8999V30.8H12.6999V30Z",
    fill: "white"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 30V30.8H13.4997V30.4C13.4997 30.2939 13.4576 30.1922 13.3826 30.1172C13.3075 30.0421 13.2058 30 13.0997 30",
    fill: "white"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 30.7998V29.9998H14.2996V30.3998C14.2996 30.5059 14.3418 30.6076 14.4168 30.6826C14.4918 30.7577 14.5935 30.7998 14.6996 30.7998",
    fill: "white"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 30H15.0996V30.8H15.8996V30Z",
    fill: "white"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 30H15.8997V30.8H16.2997C16.4058 30.8 16.5075 30.7579 16.5826 30.6828C16.6576 30.6078 16.6997 30.5061 16.6997 30.4",
    fill: "white"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2998 30.7998H23.0998V30.3998C23.0998 30.2937 23.0577 30.192 22.9826 30.117C22.9076 30.0419 22.8059 29.9998 22.6998 29.9998C22.5937 29.9998 22.492 30.0419 22.417 30.117C22.3419 30.192 22.2998 30.2937 22.2998 30.3998",
    fill: "white"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 30H23.8999V30.8H24.6999V30Z",
    fill: "white"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 30H24.6997V30.8H25.4997V30Z",
    fill: "white"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 30H27.0996V30.8H27.8996V30Z",
    fill: "white"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 30H27.8999V30.8H28.6999V30Z",
    fill: "white"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 30H29.4998V30.4C29.4998 30.5061 29.5419 30.6078 29.617 30.6828C29.692 30.7579 29.7937 30.8 29.8998 30.8C30.0059 30.8 30.1076 30.7579 30.1826 30.6828C30.2577 30.6078 30.2998 30.5061 30.2998 30.4",
    fill: "white"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 30H31.0996V30.8H31.8996V30Z",
    fill: "white"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 30H33.4995V30.8H34.2995V30Z",
    fill: "white"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2999 30.8C36.5208 30.8 36.6999 30.6209 36.6999 30.4C36.6999 30.1791 36.5208 30 36.2999 30C36.079 30 35.8999 30.1791 35.8999 30.4C35.8999 30.6209 36.079 30.8 36.2999 30.8Z",
    fill: "white"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6998 31.5998C2.92072 31.5998 3.0998 31.4207 3.0998 31.1998C3.0998 30.9789 2.92072 30.7998 2.6998 30.7998C2.47889 30.7998 2.2998 30.9789 2.2998 31.1998C2.2998 31.4207 2.47889 31.5998 2.6998 31.5998Z",
    fill: "white"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 31.6001V30.8001H4.69951V31.2001C4.69951 31.3062 4.74165 31.4079 4.81667 31.4829C4.89168 31.558 4.99343 31.6001 5.09951 31.6001",
    fill: "white"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2998 30.7998H5.4998V31.5998H5.8998C6.00589 31.5998 6.10763 31.5577 6.18265 31.4826C6.25766 31.4076 6.2998 31.3059 6.2998 31.1998",
    fill: "white"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8999 31.6001V30.8001H7.4999C7.39382 30.8001 7.29207 30.8422 7.21706 30.9173C7.14205 30.9923 7.0999 31.094 7.0999 31.2001C7.0999 31.3062 7.14205 31.4079 7.21706 31.4829C7.29207 31.558 7.39382 31.6001 7.4999 31.6001",
    fill: "white"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8999 30.7998V31.5998H8.2999C8.40599 31.5998 8.50773 31.5577 8.58274 31.4826C8.65776 31.4076 8.6999 31.3059 8.6999 31.1998C8.6999 31.0937 8.65776 30.992 8.58274 30.917C8.50773 30.8419 8.40599 30.7998 8.2999 30.7998",
    fill: "white"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 30.7998H9.49951V31.5998H10.2995V30.7998Z",
    fill: "white"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6999 30.7998H11.8999V31.5998H12.6999V30.7998Z",
    fill: "white"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 30.7998H12.6997V31.5998H13.4997V30.7998Z",
    fill: "white"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 30.7998V31.5998H13.8995C14.0056 31.5998 14.1073 31.5577 14.1824 31.4826C14.2574 31.4076 14.2995 31.3059 14.2995 31.1998C14.2995 31.0937 14.2574 30.992 14.1824 30.917C14.1073 30.8419 14.0056 30.7998 13.8995 30.7998",
    fill: "white"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 31.6001H17.4997V31.2001C17.4997 31.094 17.4576 30.9923 17.3826 30.9173C17.3075 30.8422 17.2058 30.8001 17.0997 30.8001C16.9936 30.8001 16.8919 30.8422 16.8169 30.9173C16.7418 30.9923 16.6997 31.094 16.6997 31.2001",
    fill: "white"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2998 31.6001H19.0998V30.8001H18.6998C18.5937 30.8001 18.492 30.8422 18.417 30.9173C18.3419 30.9923 18.2998 31.094 18.2998 31.2001",
    fill: "white"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 30.7998H19.0996V31.5998H19.8996V30.7998Z",
    fill: "white"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 30.7998H19.8999V31.5998H20.6999V30.7998Z",
    fill: "white"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 30.7998H20.6997V31.5998H21.4997V30.7998Z",
    fill: "white"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 30.7998H21.4995V31.5998H22.2995V30.7998Z",
    fill: "white"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0998 30.7998H22.2998V31.5998H23.0998V30.7998Z",
    fill: "white"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8996 30.7998H23.0996V31.5998H23.8996V30.7998Z",
    fill: "white"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 30.7998H23.8999V31.5998H24.6999V30.7998Z",
    fill: "white"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 30.7998H24.6995V31.5998H25.0995C25.2056 31.5998 25.3073 31.5577 25.3824 31.4826C25.4574 31.4076 25.4995 31.3059 25.4995 31.1998",
    fill: "white"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 31.6001V30.8001H26.6996C26.5935 30.8001 26.4918 30.8422 26.4168 30.9173C26.3418 30.9923 26.2996 31.094 26.2996 31.2001C26.2996 31.3062 26.3418 31.4079 26.4168 31.4829C26.4918 31.558 26.5935 31.6001 26.6996 31.6001",
    fill: "white"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 30.7998H27.0996V31.5998H27.8996V30.7998Z",
    fill: "white"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 30.7998H27.8999V31.5998H28.6999V30.7998Z",
    fill: "white"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 30.7998V31.5998H29.4997V31.1998C29.4997 31.0937 29.4576 30.992 29.3826 30.917C29.3075 30.8419 29.2058 30.7998 29.0997 30.7998",
    fill: "white"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 31.6001H31.0998V30.8001H30.6998C30.5937 30.8001 30.492 30.8422 30.417 30.9173C30.3419 30.9923 30.2998 31.094 30.2998 31.2001",
    fill: "white"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 30.7998H31.0996V31.5998H31.8996V30.7998Z",
    fill: "white"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 30.7998H31.8999V31.5998H32.6999V30.7998Z",
    fill: "white"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 30.7998H32.6997V31.5998H33.4997V30.7998Z",
    fill: "white"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 30.7998H33.4995V31.5998H34.2995V30.7998Z",
    fill: "white"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 30.7998H34.2998V31.5998H35.0998V30.7998Z",
    fill: "white"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0996 30.7998V31.5998H35.8996V31.1998C35.8996 31.0937 35.8575 30.992 35.7825 30.917C35.7074 30.8419 35.6057 30.7998 35.4996 30.7998",
    fill: "white"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 31.6001V30.8001H37.0995C36.9934 30.8001 36.8917 30.8422 36.8167 30.9173C36.7417 30.9923 36.6995 31.094 36.6995 31.2001C36.6995 31.3062 36.7417 31.4079 36.8167 31.4829C36.8917 31.558 36.9934 31.6001 37.0995 31.6001",
    fill: "white"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 30.7998V31.5998H37.8995C38.0056 31.5998 38.1073 31.5577 38.1824 31.4826C38.2574 31.4076 38.2995 31.3059 38.2995 31.1998C38.2995 31.0937 38.2574 30.992 38.1824 30.917C38.1073 30.8419 38.0056 30.7998 37.8995 30.7998",
    fill: "white"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 32.3999H9.49971V31.5999H9.09971C8.99362 31.5999 8.89188 31.642 8.81686 31.7171C8.74185 31.7921 8.69971 31.8938 8.69971 31.9999",
    fill: "white"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2998 31.6001H9.4998V32.4001H9.8998C10.0059 32.4001 10.1076 32.358 10.1826 32.2829C10.2577 32.2079 10.2998 32.1062 10.2998 32.0001",
    fill: "white"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 31.6001H11.8997V32.0001C11.8997 32.1062 11.9418 32.2079 12.0169 32.2829C12.0919 32.358 12.1936 32.4001 12.2997 32.4001C12.4058 32.4001 12.5075 32.358 12.5826 32.2829C12.6576 32.2079 12.6997 32.1062 12.6997 32.0001",
    fill: "white"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4996 32.4001C15.7205 32.4001 15.8996 32.221 15.8996 32.0001C15.8996 31.7792 15.7205 31.6001 15.4996 31.6001C15.2787 31.6001 15.0996 31.7792 15.0996 32.0001C15.0996 32.221 15.2787 32.4001 15.4996 32.4001Z",
    fill: "white"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 32.3999V31.5999H16.6995V31.9999C16.6995 32.106 16.7417 32.2077 16.8167 32.2827C16.8917 32.3578 16.9934 32.3999 17.0995 32.3999",
    fill: "white"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2995 31.6001H17.4995V32.4001H18.2995V31.6001Z",
    fill: "white"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 31.6001H18.2998V32.4001H19.0998V31.6001Z",
    fill: "white"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 31.6001H21.4995V32.4001H22.2995V31.6001Z",
    fill: "white"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 32.3999V31.5999H23.0999V31.9999C23.0999 32.106 23.142 32.2077 23.2171 32.2827C23.2921 32.3578 23.3938 32.3999 23.4999 32.3999",
    fill: "white"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6997 31.6001H23.8997V32.4001H24.2997C24.4058 32.4001 24.5075 32.358 24.5826 32.2829C24.6576 32.2079 24.6997 32.1062 24.6997 32.0001",
    fill: "white"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8995 32.4001C26.1204 32.4001 26.2995 32.221 26.2995 32.0001C26.2995 31.7792 26.1204 31.6001 25.8995 31.6001C25.6786 31.6001 25.4995 31.7792 25.4995 32.0001C25.4995 32.221 25.6786 32.4001 25.8995 32.4001Z",
    fill: "white"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 32.3999V31.5999H27.8997V31.9999C27.8997 32.106 27.9418 32.2077 28.0169 32.2827C28.0919 32.3578 28.1936 32.3999 28.2997 32.3999",
    fill: "white"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 31.6001H28.6995V32.4001H29.0995C29.2056 32.4001 29.3073 32.358 29.3824 32.2829C29.4574 32.2079 29.4995 32.1062 29.4995 32.0001",
    fill: "white"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 31.6001H30.2998V32.4001H31.0998V31.6001Z",
    fill: "white"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 31.6001H31.0996V32.4001H31.8996V31.6001Z",
    fill: "white"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 31.6001H34.2998V32.4001H35.0998V31.6001Z",
    fill: "white"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 31.6001H35.0996V32.4001H35.8996V31.6001Z",
    fill: "white"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8999 31.6001V32.4001H36.6999V32.0001C36.6999 31.894 36.6578 31.7923 36.5827 31.7173C36.5077 31.6422 36.406 31.6001 36.2999 31.6001",
    fill: "white"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 32.3999H8.69951V32.7999C8.69951 32.906 8.74165 33.0077 8.81667 33.0827C8.89168 33.1578 8.99343 33.1999 9.09951 33.1999C9.2056 33.1999 9.30734 33.1578 9.38235 33.0827C9.45737 33.0077 9.49951 32.906 9.49951 32.7999",
    fill: "white"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2998 33.2002H11.0998V32.4002H10.6998C10.5937 32.4002 10.492 32.4423 10.417 32.5174C10.3419 32.5924 10.2998 32.6941 10.2998 32.8002",
    fill: "white"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 32.3999V33.1999H11.8996V32.7999C11.8996 32.6938 11.8575 32.5921 11.7825 32.5171C11.7074 32.442 11.6057 32.3999 11.4996 32.3999",
    fill: "white"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 33.2002V32.4002H13.0995C12.9934 32.4002 12.8917 32.4423 12.8167 32.5174C12.7417 32.5924 12.6995 32.6941 12.6995 32.8002C12.6995 32.9063 12.7417 33.008 12.8167 33.083C12.8917 33.1581 12.9934 33.2002 13.0995 33.2002",
    fill: "white"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 32.3999V33.1999H13.8995C14.0056 33.1999 14.1073 33.1578 14.1824 33.0827C14.2574 33.0077 14.2995 32.906 14.2995 32.7999C14.2995 32.6938 14.2574 32.5921 14.1824 32.5171C14.1073 32.442 14.0056 32.3999 13.8995 32.3999",
    fill: "white"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 33.2002H16.6999V32.8002C16.6999 32.6941 16.6578 32.5924 16.5827 32.5174C16.5077 32.4423 16.406 32.4002 16.2999 32.4002C16.1938 32.4002 16.0921 32.4423 16.0171 32.5174C15.942 32.5924 15.8999 32.6941 15.8999 32.8002",
    fill: "white"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 32.3999H18.2998V33.1999H19.0998V32.3999Z",
    fill: "white"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2999 33.1999C20.5208 33.1999 20.6999 33.0208 20.6999 32.7999C20.6999 32.579 20.5208 32.3999 20.2999 32.3999C20.079 32.3999 19.8999 32.579 19.8999 32.7999C19.8999 33.0208 20.079 33.1999 20.2999 33.1999Z",
    fill: "white"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 32.3999H21.4995V33.1999H22.2995V32.3999Z",
    fill: "white"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 33.2002V32.4002H26.6996C26.5935 32.4002 26.4918 32.4423 26.4168 32.5174C26.3418 32.5924 26.2996 32.6941 26.2996 32.8002C26.2996 32.9063 26.3418 33.008 26.4168 33.083C26.4918 33.1581 26.5935 33.2002 26.6996 33.2002",
    fill: "white"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 32.3999V33.1999H27.4996C27.6057 33.1999 27.7074 33.1578 27.7825 33.0827C27.8575 33.0077 27.8996 32.906 27.8996 32.7999C27.8996 32.6938 27.8575 32.5921 27.7825 32.5171C27.7074 32.442 27.6057 32.3999 27.4996 32.3999",
    fill: "white"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 33.2002H30.2995V32.4002H29.8995C29.7934 32.4002 29.6917 32.4423 29.6167 32.5174C29.5417 32.5924 29.4995 32.6941 29.4995 32.8002",
    fill: "white"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 32.3999H30.2998V33.1999H31.0998V32.3999Z",
    fill: "white"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 32.3999H31.0996V33.1999H31.8996V32.3999Z",
    fill: "white"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0997 33.1999C33.3206 33.1999 33.4997 33.0208 33.4997 32.7999C33.4997 32.579 33.3206 32.3999 33.0997 32.3999C32.8788 32.3999 32.6997 32.579 32.6997 32.7999C32.6997 33.0208 32.8788 33.1999 33.0997 33.1999Z",
    fill: "white"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 32.3999H34.2998V33.1999H35.0998V32.3999Z",
    fill: "white"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 32.3999H35.0996V33.1999H35.8996V32.3999Z",
    fill: "white"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6999 32.3999H35.8999V33.1999H36.6999V32.3999Z",
    fill: "white"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 32.3999V33.1999H37.0997C37.2058 33.1999 37.3075 33.1578 37.3825 33.0827C37.4576 33.0077 37.4997 32.906 37.4997 32.7999C37.4997 32.6938 37.4576 32.5921 37.3825 32.5171C37.3075 32.442 37.2058 32.3999 37.0997 32.3999",
    fill: "white"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 33.2002H10.2998V34.0002H11.0998V33.2002Z",
    fill: "white"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8999 33.2002H11.0999V34.0002H11.4999C11.606 34.0002 11.7077 33.9581 11.7827 33.883C11.8578 33.808 11.8999 33.7063 11.8999 33.6002",
    fill: "white"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 34V33.2H14.6996C14.5935 33.2 14.4918 33.2421 14.4168 33.3172C14.3418 33.3922 14.2996 33.4939 14.2996 33.6C14.2996 33.7061 14.3418 33.8078 14.4168 33.8828C14.4918 33.9579 14.5935 34 14.6996 34",
    fill: "white"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 33.2002H15.0996V34.0002H15.8996V33.2002Z",
    fill: "white"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6999 33.2002H15.8999V34.0002H16.6999V33.2002Z",
    fill: "white"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 33.2002V34.0002H17.0997C17.2058 34.0002 17.3075 33.9581 17.3826 33.883C17.4576 33.808 17.4997 33.7063 17.4997 33.6002C17.4997 33.4941 17.4576 33.3924 17.3826 33.3174C17.3075 33.2423 17.2058 33.2002 17.0997 33.2002",
    fill: "white"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 33.2002H18.2998V34.0002H19.0998V33.2002Z",
    fill: "white"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 33.2002H21.4995V34.0002H22.2995V33.2002Z",
    fill: "white"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 34V33.2H23.4999C23.3938 33.2 23.2921 33.2421 23.2171 33.3172C23.142 33.3922 23.0999 33.4939 23.0999 33.6C23.0999 33.7061 23.142 33.8078 23.2171 33.8828C23.2921 33.9579 23.3938 34 23.4999 34",
    fill: "white"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 33.2002H23.8999V34.0002H24.6999V33.2002Z",
    fill: "white"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 33.2002H24.6997V34.0002H25.4997V33.2002Z",
    fill: "white"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 33.2002V34.0002H26.2995V33.6002C26.2995 33.4941 26.2574 33.3924 26.1824 33.3174C26.1073 33.2423 26.0056 33.2002 25.8995 33.2002",
    fill: "white"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 33.2002H29.4998V33.6002C29.4998 33.7063 29.5419 33.808 29.617 33.883C29.692 33.9581 29.7937 34.0002 29.8998 34.0002C30.0059 34.0002 30.1076 33.9581 30.1826 33.883C30.2577 33.808 30.2998 33.7063 30.2998 33.6002",
    fill: "white"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 33.2002H31.0996V34.0002H31.8996V33.2002Z",
    fill: "white"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 33.2002H34.2998V34.0002H35.0998V33.2002Z",
    fill: "white"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 33.2002H35.8997V33.6002C35.8997 33.7063 35.9418 33.808 36.0169 33.883C36.0919 33.9581 36.1936 34.0002 36.2997 34.0002C36.4058 34.0002 36.5075 33.9581 36.5826 33.883C36.6576 33.808 36.6997 33.7063 36.6997 33.6002",
    fill: "white"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 34.7998H9.49971V34.3998C9.49971 34.2937 9.45756 34.192 9.38255 34.117C9.30753 34.0419 9.20579 33.9998 9.09971 33.9998C8.99362 33.9998 8.89188 34.0419 8.81686 34.117C8.74185 34.192 8.69971 34.2937 8.69971 34.3998",
    fill: "white"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 34H10.2998V34.8H11.0998V34Z",
    fill: "white"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0997 34.8C13.3206 34.8 13.4997 34.6209 13.4997 34.4C13.4997 34.1791 13.3206 34 13.0997 34C12.8788 34 12.6997 34.1791 12.6997 34.4C12.6997 34.6209 12.8788 34.8 13.0997 34.8Z",
    fill: "white"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6999 34H15.8999V34.8H16.6999V34Z",
    fill: "white"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 34.7998H18.2995V33.9998H17.8995C17.7934 33.9998 17.6917 34.0419 17.6167 34.117C17.5417 34.192 17.4995 34.2937 17.4995 34.3998",
    fill: "white"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 34H18.2998V34.8H19.0998V34Z",
    fill: "white"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 34H19.0996V34.8H19.8996V34Z",
    fill: "white"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 34H19.8999V34.8H20.6999V34Z",
    fill: "white"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 34H20.6997V34.8H21.4997V34Z",
    fill: "white"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2998 34H21.4998V34.8H21.8998C22.0059 34.8 22.1076 34.7579 22.1826 34.6828C22.2577 34.6078 22.2998 34.5061 22.2998 34.4",
    fill: "white"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 34H25.4995V34.8H26.2995V34Z",
    fill: "white"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8999 34.7998H28.6999V34.3998C28.6999 34.2937 28.6578 34.192 28.5827 34.117C28.5077 34.0419 28.406 33.9998 28.2999 33.9998C28.1938 33.9998 28.0921 34.0419 28.0171 34.117C27.942 34.192 27.8999 34.2937 27.8999 34.3998",
    fill: "white"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 34.7998H31.0998V33.9998H30.6998C30.5937 33.9998 30.492 34.0419 30.417 34.117C30.3419 34.192 30.2998 34.2937 30.2998 34.3998",
    fill: "white"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 34H31.0996V34.8H31.8996V34Z",
    fill: "white"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 34H31.8999V34.8H32.6999V34Z",
    fill: "white"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 34H32.6997V34.8H33.4997V34Z",
    fill: "white"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 34H33.4995V34.8H34.2995V34Z",
    fill: "white"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 34H34.2998V34.8H35.0998V34Z",
    fill: "white"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0996 34V34.8H35.8996V34.4C35.8996 34.2939 35.8575 34.1922 35.7825 34.1172C35.7074 34.0421 35.6057 34 35.4996 34",
    fill: "white"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 34.7998H38.2995V34.3998C38.2995 34.2937 38.2574 34.192 38.1824 34.117C38.1073 34.0419 38.0056 33.9998 37.8995 33.9998C37.7934 33.9998 37.6917 34.0419 37.6167 34.117C37.5417 34.192 37.4995 34.2937 37.4995 34.3998",
    fill: "white"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 34.7998H8.69951V35.1998C8.69951 35.3059 8.74166 35.4076 8.81667 35.4826C8.89169 35.5577 8.99343 35.5998 9.09951 35.5998C9.2056 35.5998 9.30734 35.5577 9.38235 35.4826C9.45737 35.4076 9.49951 35.3059 9.49951 35.1998",
    fill: "white"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 34.7998H10.2998V35.5998H11.0998V34.7998Z",
    fill: "white"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2999 35.5998C12.5208 35.5998 12.6999 35.4207 12.6999 35.1998C12.6999 34.9789 12.5208 34.7998 12.2999 34.7998C12.079 34.7998 11.8999 34.9789 11.8999 35.1998C11.8999 35.4207 12.079 35.5998 12.2999 35.5998Z",
    fill: "white"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8995 35.5998C14.1204 35.5998 14.2995 35.4207 14.2995 35.1998C14.2995 34.9789 14.1204 34.7998 13.8995 34.7998C13.6786 34.7998 13.4995 34.9789 13.4995 35.1998C13.4995 35.4207 13.6786 35.5998 13.8995 35.5998Z",
    fill: "white"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 35.6001H15.8996V34.8001H15.4996C15.3935 34.8001 15.2918 34.8422 15.2168 34.9173C15.1418 34.9923 15.0996 35.094 15.0996 35.2001",
    fill: "white"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 34.7998H15.8997V35.5998H16.2997C16.4058 35.5998 16.5075 35.5577 16.5825 35.4826C16.6576 35.4076 16.6997 35.3059 16.6997 35.1998",
    fill: "white"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2998 34.7998H17.4998V35.1998C17.4998 35.3059 17.5419 35.4076 17.617 35.4826C17.692 35.5577 17.7937 35.5998 17.8998 35.5998C18.0059 35.5998 18.1076 35.5577 18.1826 35.4826C18.2577 35.4076 18.2998 35.3059 18.2998 35.1998",
    fill: "white"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 34.7998H20.6997V35.5998H21.4997V34.7998Z",
    fill: "white"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 35.6001V34.8001H25.0995C24.9934 34.8001 24.8917 34.8422 24.8167 34.9173C24.7417 34.9923 24.6995 35.094 24.6995 35.2001C24.6995 35.3062 24.7417 35.4079 24.8167 35.4829C24.8917 35.558 24.9934 35.6001 25.0995 35.6001",
    fill: "white"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2998 34.7998H25.4998V35.5998H25.8998C26.0059 35.5998 26.1076 35.5577 26.1826 35.4826C26.2577 35.4076 26.2998 35.3059 26.2998 35.1998",
    fill: "white"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 34.7998H27.8999V35.5998H28.6999V34.7998Z",
    fill: "white"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 35.6001H30.2995V34.8001H29.8995C29.7934 34.8001 29.6917 34.8422 29.6167 34.9173C29.5417 34.9923 29.4995 35.094 29.4995 35.2001",
    fill: "white"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 34.7998H30.2996V35.5998H30.6996C30.8057 35.5998 30.9074 35.5577 30.9825 35.4826C31.0575 35.4076 31.0996 35.3059 31.0996 35.1998",
    fill: "white"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4995 35.6001V34.8001H32.6995V35.2001C32.6995 35.3062 32.7417 35.4079 32.8167 35.4829C32.8917 35.558 32.9934 35.6001 33.0995 35.6001",
    fill: "white"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 34.7998H33.4995V35.5998H34.2995V34.7998Z",
    fill: "white"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 34.7998H34.2998V35.5998H35.0998V34.7998Z",
    fill: "white"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8999 34.7998H35.0999V35.5998H35.4999C35.606 35.5998 35.7077 35.5577 35.7827 35.4826C35.8578 35.4076 35.8999 35.3059 35.8999 35.1998",
    fill: "white"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 34.7998H37.4995V35.5998H38.2995V34.7998Z",
    fill: "white"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 35.6001H10.2998V36.4001H11.0998V35.6001Z",
    fill: "white"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 35.6001V36.4001H11.4996C11.6057 36.4001 11.7074 36.358 11.7825 36.2829C11.8575 36.2079 11.8996 36.1062 11.8996 36.0001C11.8996 35.894 11.8575 35.7923 11.7825 35.7173C11.7074 35.6422 11.6057 35.6001 11.4996 35.6001",
    fill: "white"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 35.6001H15.0996V36.4001H15.8996V35.6001Z",
    fill: "white"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 36.3999H17.4997V35.9999C17.4997 35.8938 17.4576 35.7921 17.3825 35.7171C17.3075 35.642 17.2058 35.5999 17.0997 35.5999C16.9936 35.5999 16.8919 35.642 16.8169 35.7171C16.7419 35.7921 16.6997 35.8938 16.6997 35.9999",
    fill: "white"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0996 36.3999H19.8996V35.5999H19.4996C19.3935 35.5999 19.2918 35.642 19.2168 35.7171C19.1418 35.7921 19.0996 35.8938 19.0996 35.9999",
    fill: "white"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 35.6001H19.8999V36.4001H20.6999V35.6001Z",
    fill: "white"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 35.6001H20.6997V36.4001H21.4997V35.6001Z",
    fill: "white"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 35.6001H21.4995V36.4001H22.2995V35.6001Z",
    fill: "white"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2998 35.6001V36.4001H22.6998C22.8059 36.4001 22.9076 36.358 22.9826 36.2829C23.0577 36.2079 23.0998 36.1062 23.0998 36.0001C23.0998 35.894 23.0577 35.7923 22.9826 35.7173C22.9076 35.6422 22.8059 35.6001 22.6998 35.6001",
    fill: "white"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2998 36.3999H27.0998V35.9999C27.0998 35.8938 27.0577 35.7921 26.9826 35.7171C26.9076 35.642 26.8059 35.5999 26.6998 35.5999C26.5937 35.5999 26.492 35.642 26.417 35.7171C26.3419 35.7921 26.2998 35.8938 26.2998 35.9999",
    fill: "white"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 35.6001H27.8999V36.4001H28.6999V35.6001Z",
    fill: "white"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 35.6001H29.4995V36.4001H30.2995V35.6001Z",
    fill: "white"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8999 36.3999V35.5999H31.4999C31.3938 35.5999 31.2921 35.642 31.2171 35.7171C31.142 35.7921 31.0999 35.8938 31.0999 35.9999C31.0999 36.106 31.142 36.2077 31.2171 36.2827C31.2921 36.3578 31.3938 36.3999 31.4999 36.3999",
    fill: "white"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8999 35.6001V36.4001H32.6999V36.0001C32.6999 35.894 32.6578 35.7923 32.5827 35.7173C32.5077 35.6422 32.406 35.6001 32.2999 35.6001",
    fill: "white"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 35.6001H33.4995V36.4001H34.2995V35.6001Z",
    fill: "white"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0996 35.6001H34.2996V36.4001H34.6996C34.8057 36.4001 34.9074 36.358 34.9825 36.2829C35.0575 36.2079 35.0996 36.1062 35.0996 36.0001",
    fill: "white"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8999 36.3999H36.6999V35.5999H36.2999C36.1938 35.5999 36.0921 35.642 36.0171 35.7171C35.942 35.7921 35.8999 35.8938 35.8999 35.9999",
    fill: "white"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 35.6001H36.6997V36.4001H37.4997V35.6001Z",
    fill: "white"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 35.6001H37.4995V36.4001H38.2995V35.6001Z",
    fill: "white"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 36.3999H10.2996V36.7999C10.2996 36.906 10.3418 37.0077 10.4168 37.0827C10.4918 37.1578 10.5935 37.1999 10.6996 37.1999C10.8057 37.1999 10.9074 37.1578 10.9825 37.0827C11.0575 37.0077 11.0996 36.906 11.0996 36.7999",
    fill: "white"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 37.2002H13.4997V36.4002H13.0997C12.9936 36.4002 12.8919 36.4423 12.8169 36.5174C12.7419 36.5924 12.6997 36.6941 12.6997 36.8002",
    fill: "white"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 36.3999V37.1999H13.8995C14.0056 37.1999 14.1073 37.1578 14.1824 37.0827C14.2574 37.0077 14.2995 36.906 14.2995 36.7999C14.2995 36.6938 14.2574 36.5921 14.1824 36.5171C14.1073 36.442 14.0056 36.3999 13.8995 36.3999",
    fill: "white"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 37.2002V36.4002H15.0999V36.8002C15.0999 36.9063 15.142 37.008 15.2171 37.083C15.2921 37.1581 15.3938 37.2002 15.4999 37.2002",
    fill: "white"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6999 36.3999H15.8999V37.1999H16.6999V36.3999Z",
    fill: "white"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 36.3999H16.6997V37.1999H17.4997V36.3999Z",
    fill: "white"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2995 36.3999H17.4995V37.1999H18.2995V36.3999Z",
    fill: "white"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 36.3999H18.2998V37.1999H19.0998V36.3999Z",
    fill: "white"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 36.3999H19.0996V37.1999H19.8996V36.3999Z",
    fill: "white"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6997 36.3999H19.8997V37.1999H20.2997C20.4058 37.1999 20.5075 37.1578 20.5825 37.0827C20.6576 37.0077 20.6997 36.906 20.6997 36.7999",
    fill: "white"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 36.3999H21.4995V37.1999H22.2995V36.3999Z",
    fill: "white"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4996 37.1999C23.7205 37.1999 23.8996 37.0208 23.8996 36.7999C23.8996 36.579 23.7205 36.3999 23.4996 36.3999C23.2787 36.3999 23.0996 36.579 23.0996 36.7999C23.0996 37.0208 23.2787 37.1999 23.4996 37.1999Z",
    fill: "white"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0997 37.1999C25.3206 37.1999 25.4997 37.0208 25.4997 36.7999C25.4997 36.579 25.3206 36.3999 25.0997 36.3999C24.8788 36.3999 24.6997 36.579 24.6997 36.7999C24.6997 37.0208 24.8788 37.1999 25.0997 37.1999Z",
    fill: "white"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 36.3999H26.2998V37.1999H27.0998V36.3999Z",
    fill: "white"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 36.3999H27.0996V37.1999H27.8996V36.3999Z",
    fill: "white"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 36.3999H27.8999V37.1999H28.6999V36.3999Z",
    fill: "white"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 36.3999H28.6997V37.1999H29.4997V36.3999Z",
    fill: "white"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 36.3999H29.4998V37.1999H29.8998C30.0059 37.1999 30.1076 37.1578 30.1826 37.0827C30.2577 37.0077 30.2998 36.906 30.2998 36.7999",
    fill: "white"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 36.3999H31.8999V37.1999H32.6999V36.3999Z",
    fill: "white"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 36.3999H32.6997V37.1999H33.4997V36.3999Z",
    fill: "white"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 36.3999H33.4995V37.1999H34.2995V36.3999Z",
    fill: "white"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 37.2002V36.4002H35.8997V36.8002C35.8997 36.9063 35.9419 37.008 36.0169 37.083C36.0919 37.1581 36.1936 37.2002 36.2997 37.2002",
    fill: "white"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 36.3999H36.6997V37.1999H37.4997V36.3999Z",
    fill: "white"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2998 36.3999H37.4998V37.1999H37.8998C38.0059 37.1999 38.1076 37.1578 38.1826 37.0827C38.2577 37.0077 38.2998 36.906 38.2998 36.7999",
    fill: "white"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 37.2002H12.6995V37.6002C12.6995 37.7063 12.7417 37.808 12.8167 37.883C12.8917 37.9581 12.9934 38.0002 13.0995 38.0002C13.2056 38.0002 13.3073 37.9581 13.3824 37.883C13.4574 37.808 13.4995 37.7063 13.4995 37.6002",
    fill: "white"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6998 38.0002C14.9207 38.0002 15.0998 37.8211 15.0998 37.6002C15.0998 37.3793 14.9207 37.2002 14.6998 37.2002C14.4789 37.2002 14.2998 37.3793 14.2998 37.6002C14.2998 37.8211 14.4789 38.0002 14.6998 38.0002Z",
    fill: "white"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 38V37.2H15.8997V37.6C15.8997 37.7061 15.9418 37.8078 16.0169 37.8828C16.0919 37.9579 16.1936 38 16.2997 38",
    fill: "white"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 37.2002H16.6995V38.0002H17.0995C17.2056 38.0002 17.3073 37.9581 17.3824 37.883C17.4574 37.808 17.4995 37.7063 17.4995 37.6002",
    fill: "white"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0996 38V37.2H18.2996V37.6C18.2996 37.7061 18.3418 37.8078 18.4168 37.8828C18.4918 37.9579 18.5935 38 18.6996 38",
    fill: "white"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8999 37.2002H19.0999V38.0002H19.4999C19.606 38.0002 19.7077 37.9581 19.7827 37.883C19.8578 37.808 19.8999 37.7063 19.8999 37.6002",
    fill: "white"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2998 38V37.2H21.4998V37.6C21.4998 37.7061 21.5419 37.8078 21.617 37.8828C21.692 37.9579 21.7937 38 21.8998 38",
    fill: "white"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2998 37.2002V38.0002H22.6998C22.8059 38.0002 22.9076 37.9581 22.9826 37.883C23.0577 37.808 23.0998 37.7063 23.0998 37.6002C23.0998 37.4941 23.0577 37.3924 22.9826 37.3174C22.9076 37.2423 22.8059 37.2002 22.6998 37.2002",
    fill: "white"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2998 38V37.2H25.8998C25.7937 37.2 25.692 37.2421 25.617 37.3172C25.5419 37.3922 25.4998 37.4939 25.4998 37.6C25.4998 37.7061 25.5419 37.8078 25.617 37.8828C25.692 37.9579 25.7937 38 25.8998 38",
    fill: "white"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 37.2002H26.2996V38.0002H26.6996C26.8057 38.0002 26.9074 37.9581 26.9825 37.883C27.0575 37.808 27.0996 37.7063 27.0996 37.6002",
    fill: "white"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 38V37.2H27.8997V37.6C27.8997 37.7061 27.9418 37.8078 28.0169 37.8828C28.0919 37.9579 28.1936 38 28.2997 38",
    fill: "white"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 37.2002H28.6995V38.0002H29.0995C29.2056 38.0002 29.3073 37.9581 29.3824 37.883C29.4574 37.808 29.4995 37.7063 29.4995 37.6002",
    fill: "white"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8999 38V37.2H31.4999C31.3938 37.2 31.2921 37.2421 31.2171 37.3172C31.142 37.3922 31.0999 37.4939 31.0999 37.6C31.0999 37.7061 31.142 37.8078 31.2171 37.8828C31.2921 37.9579 31.3938 38 31.4999 38",
    fill: "white"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 37.2002H31.8999V38.0002H32.6999V37.2002Z",
    fill: "white"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 37.2002H32.6997V38.0002H33.4997V37.2002Z",
    fill: "white"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 37.2002H33.4995V38.0002H34.2995V37.2002Z",
    fill: "white"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2998 37.2002V38.0002H34.6998C34.8059 38.0002 34.9076 37.9581 34.9826 37.883C35.0577 37.808 35.0998 37.7063 35.0998 37.6002C35.0998 37.4941 35.0577 37.3924 34.9826 37.3174C34.9076 37.2423 34.8059 37.2002 34.6998 37.2002",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2624_43446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2998 0H0.299805V40H40.2998V0Z",
    fill: "#11406F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2624_43446",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2624_43446",
    transform: "scale(0.0144928)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2624_43446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.299805)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2624_43446",
    width: 69,
    height: 69,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAABFCAYAAAAcjSspAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIuSURBVHgB7ZqBUQIxEEW/jgXYgWsFWgIdaAfYgVoB14FYAZRgB4wdSAVcB2IFmAzHwEgSwiaXO/C/mR0g4ZLw2exdkgUIIYQQQgg5ZS5QDmnMxZexJf4hlbGVxwQ94hJkD4rigKI4uEJero09Yh0jbprP102dIJ0XYw/NexuYa2Ofxj7QQ8TYxNg3/ME0ZBLZz9Rz/cLYCD3CeoZWjFyi7Ioj6Jgh0sTILUrnwgjSPaQNUazNkEDK3WeCbRDtGwOsg3JR7hHvBdabFgh7lcR1i3FEW7v9FmWM8JweYN+LKqSLsoscaHPVjKMYMxz/AyvFNTGE/iDVFNLGFF8ssavdGmWpAnV3UKAVRTzlXSz/s/eZ21POgtwLwhpnAFfJDrSr5NpT/oNuqD3lqvFoRblFv8g6Hk4fBxTFAUVxQFEcUBQHFMUBRXGgfU4RT/kS3SwKxVNedDy+/YtJ4JoK7eynaMfjhdPHAUVxkFsUwRmgFaX2lJ/F5pNWFF9EF5TnPlCn2jrQijL3lFtPGaEsb4G6Ggq0zyl2137oqauw9ph5870NN0hHsPVG+/qMsKcUTdGwHrHKaBLXbfRZctJ5ckpMeUe/eUUHWG9ZoJ+eUqFDBHmEkcj+phFtTdEDBMfN9TZFKZ5+cYgnhA/e2xLFplyMkfEZqa00dHubtDFHdspsVuOj5/v2iKLGYQZ/2twc6J9sCnuFdE8pAlfJDiiKg9wZ1yE2GdKEEEIIIYQQUppf2ax6+KyTGoEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateQr);
export default __webpack_public_path__ + "static/media/corporate-qr.2c9cecb3512936719701995f3b36fe95.svg";
export { ForwardRef as ReactComponent };